webpackJsonp([1],{

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  "data-v-1a52c5ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(41);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = {
  en_US: __webpack_require__(661),
  fr_FR: __webpack_require__(662),
  tr_TR: __webpack_require__(663)
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.language.locale,
  fallbackLocale: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.language.fallbackLocale,
  messages: messages
}));

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  "data-v-286b9e29",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gameStates; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);



var gameStates = {
  IS_RUNNING: 'IS_RUNNING',
  IS_NOT_RUNNING: 'IS_NOT_RUNNING'
};

var state = {
  state: gameStates.IS_NOT_RUNNING
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* UPDATE_GAME_STATE */], function (state, payload) {
  state.state = payload;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(432)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  "data-v-7d965f46",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  "data-v-20076387",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(435)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  "data-v-c4de648c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ElementProfile__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ElementProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ElementProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PeriodicTable__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PeriodicTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PeriodicTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Sidebar_PeriodicTableOptions__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Sidebar_PeriodicTableOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Sidebar_PeriodicTableOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Sidebar_ElementProfileOptions__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Sidebar_ElementProfileOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Sidebar_ElementProfileOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_About__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_GameMode__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_GameMode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_GameMode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Sidebar_GameModeOptions__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Sidebar_GameModeOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Sidebar_GameModeOptions__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: '/mendelable/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a,
    children: [{
      path: '',
      name: 'PeriodicTable',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_4__components_PeriodicTable___default.a,
        sidebar: __WEBPACK_IMPORTED_MODULE_5__components_Sidebar_PeriodicTableOptions___default.a
      }
    }, {
      path: 'element/:id',
      name: 'ElementProfile',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_3__components_ElementProfile___default.a,
        sidebar: __WEBPACK_IMPORTED_MODULE_6__components_Sidebar_ElementProfileOptions___default.a
      }
    }, {
      path: 'game',
      name: 'GameMode',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_8__components_GameMode___default.a,
        sidebar: __WEBPACK_IMPORTED_MODULE_9__components_Sidebar_GameModeOptions___default.a
      }
    }, {
      path: 'about',
      name: 'About',
      component: __WEBPACK_IMPORTED_MODULE_7__components_About___default.a
    }]
  }, {
    path: '*',
    redirect: {
      name: 'PeriodicTable'
    }
  }]
}));

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(434)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(28);







window.$ = window.jQuery = __webpack_require__(300);
window.tether = window.Tether = __webpack_require__(301);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colors; });
var colors = {
  'non-metal': '3, 169, 244',
  'halogen': '240, 98, 146',
  'metalloid': '103, 58, 183',
  'metal': '25, 202, 167',
  'alkali-metal': '244, 67, 54',
  'alkaline-earth-metal': '255, 152, 0',
  'transition-metal': '239, 187, 49',
  'noble-gas': '0, 188, 212',
  'lanthanoid': '139, 195, 74',
  'actinoid': '205, 220, 57'
};

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decrementMain", function() { return decrementMain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "incrementMain", function() { return incrementMain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(28);



var decrementMain = function decrementMain(_ref) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["h" /* DECREMENT_MAIN_COUNTER */]);
};

var incrementMain = function incrementMain(_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["i" /* INCREMENT_MAIN_COUNTER */]);
};

var changeLanguage = function changeLanguage(_ref3, payload) {
  var commit = _ref3.commit;

  __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].locale = payload;
  localStorage.setItem('locale', payload);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* UPDATE_LOCALE */], payload);
};

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainCounter", function() { return mainCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "localizedElements", function() { return localizedElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filteredElements", function() { return filteredElements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);




var mainCounter = function mainCounter(state) {
  return state.counters.main;
};

var localizedElements = function localizedElements(state) {
  var locale = state.language.locale === 'en_US' ? 'default' : state.language.locale;
  var defaultElements = state.elements.default;
  var localizedData = state.elements[locale];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(defaultElements).mergeDeep(localizedData).toJS();
};

var filteredElements = function filteredElements(state) {
  var search = state.filters.search;
  var groups = state.filters.groups;
  var filteredDataIds = [];
  var localizedData = localizedElements(state);

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localizedData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (localizedData[key].name.toLowerCase().includes(search.toLowerCase())) {
        filteredDataIds.push(+key);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (groups.length > 0) {
    var idsFilteredByGroups = [];

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(filteredDataIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var id = _step2.value;

        if (groups.includes(localizedData[id].elementGroup)) {
          idsFilteredByGroups.push(+id);
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    filteredDataIds = idsFilteredByGroups;
  }

  return filteredDataIds;
};

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);


var _mutations;



var state = {
  debug: false,
  simpleView: true
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* TOGGLE_DEBUG */], function (state) {
  state.debug = !state.debug;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* TOGGLE_SIMPLE_VIEW */], function (state) {
  state.simpleView = !state.simpleView;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);


var _mutations;



var state = {
  main: 0
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* DECREMENT_MAIN_COUNTER */], function (state) {
  state.main--;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* INCREMENT_MAIN_COUNTER */], function (state) {
  state.main++;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = __webpack_require__(659);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state
});

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);


var _mutations;



var state = {
  search: '',
  groups: []
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* UPDATE_SEARCH */], function (state, payload) {
  state.search = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ADD_GROUP */], function (state, payload) {
  if (state.groups.indexOf(payload) === -1) {
    state.groups.push(payload);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* REMOVE_GROUP */], function (state, payload) {
  var index = state.groups.indexOf(payload);
  if (index !== -1) {
    state.groups.splice(index, 1);
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);



var getNavigatorLanguage = function getNavigatorLanguage() {
  console.log('navigator.language', window.navigator.language);
  var language = window.navigator.language.toLowerCase().replace('-', '_');

  switch (language) {
    case 'fr':
    case 'fr_fr':
      return 'fr_FR';
    default:
      return 'en_US';
  }
};

var state = {
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : getNavigatorLanguage(),
  fallbackLocale: 'en_US'
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* UPDATE_LOCALE */], function (state, payload) {
  state.locale = payload;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {
      name: '',
      email: '',
      message: '',
      paypalLink: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=CLK49A83DXCQ8'
    };
  },

  computed: {
    isValidEmail: function isValidEmail() {
      var regex = new RegExp('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}');
      return regex.test(this.email);
    }
  },
  methods: {
    canSubmit: function canSubmit() {
      return this.name && this.isValidEmail && this.message;
    },
    trackClick: function trackClick(url) {
      window.ga('send', 'event', 'outbound', 'click', url);
    }
  }
});

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementDefinition__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementDefinition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementDefinition__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'element-badge',
  components: {
    ElementDefinition: __WEBPACK_IMPORTED_MODULE_0__ElementDefinition___default.a
  },
  props: ['element']
});

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'element-definition',
  props: ['element', 'detailed'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    simpleView: function simpleView(state) {
      return state.configuration.simpleView;
    }
  }))
});

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElementProfile_ElementGeneralProperties__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElementProfile_ElementGeneralProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ElementProfile_ElementGeneralProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ElementProfile_ElementAtomicProperties__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ElementProfile_ElementAtomicProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ElementProfile_ElementAtomicProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ElementProfile_ElementHistoricalProperties__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ElementProfile_ElementHistoricalProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ElementProfile_ElementHistoricalProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_BarChart__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_BarChart__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'element-profile',
  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_6__shared_BarChart___default.a, ElementGeneralProperties: __WEBPACK_IMPORTED_MODULE_3__ElementProfile_ElementGeneralProperties___default.a, ElementAtomicProperties: __WEBPACK_IMPORTED_MODULE_4__ElementProfile_ElementAtomicProperties___default.a, ElementHistoricalProperties: __WEBPACK_IMPORTED_MODULE_5__ElementProfile_ElementHistoricalProperties___default.a
  },
  mounted: function mounted() {
    this.renderGrid();
  },
  watch: {
    element: function element() {
      this.renderGrid();
    },
    debug: function debug() {
      this.renderGrid();
    }
  },
  methods: {
    renderGrid: function renderGrid() {
      var _this = this;

      this.$nextTick(function () {
        var ctx = _this.$refs['c-masonry-grid'];

        new __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a(ctx, {
          itemSelector: '.c-masonry-grid__item',
          columnWidth: '.c-masonry-grid__sizer',
          percentPosition: true
        });
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    elements: 'localizedElements'
  }), {
    element: function element() {
      return this.elements[this.$route.params.id];
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    debug: function debug(state) {
      return state.configuration.debug;
    }
  }))
});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementBadge__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_DoughnutChart__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_DoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_DoughnutChart__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'element-atomic-properties',
  props: ['element'],
  components: {
    DoughnutChart: __WEBPACK_IMPORTED_MODULE_1__shared_DoughnutChart___default.a, ElementBadge: __WEBPACK_IMPORTED_MODULE_0__ElementBadge___default.a
  }
});

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ElementBadge__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ElementBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ElementBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_BarChart__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeaturedValue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeaturedValue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FeaturedValue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_Highlight__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_Highlight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shared_Highlight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_LineChart__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_LineChart__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'element-general-properties',
  props: ['element', 'preview'],
  components: {
    Highlight: __WEBPACK_IMPORTED_MODULE_5__shared_Highlight___default.a, FeaturedValue: __WEBPACK_IMPORTED_MODULE_4__FeaturedValue___default.a, BarChart: __WEBPACK_IMPORTED_MODULE_3__shared_BarChart___default.a, ElementBadge: __WEBPACK_IMPORTED_MODULE_2__ElementBadge___default.a, LineChart: __WEBPACK_IMPORTED_MODULE_6__shared_LineChart___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    debug: function debug(state) {
      return state.configuration.debug;
    }
  }))
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeaturedValue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeaturedValue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FeaturedValue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'element-historical-properties',
  components: {
    FeaturedValue: __WEBPACK_IMPORTED_MODULE_0__FeaturedValue___default.a
  },
  props: ['element'],
  computed: {
    discoveryAuthorImage: function discoveryAuthorImage() {
      try {
        return __webpack_require__(660)("./" + this.element.atomicNumber + '.jpg');
      } catch (e) {}
    }
  }
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'featured-value',
  props: ['value', 'title', 'element', 'colored']
});

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_bus__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_game__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ElementBadge__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ElementBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ElementBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ElementDefinition__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ElementDefinition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ElementDefinition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ElementProfile_ElementGeneralProperties__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ElementProfile_ElementGeneralProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ElementProfile_ElementGeneralProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_Countdown__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_Countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__shared_Countdown__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'periodic-table',
  components: {
    Countdown: __WEBPACK_IMPORTED_MODULE_10__shared_Countdown___default.a, ElementGeneralProperties: __WEBPACK_IMPORTED_MODULE_9__ElementProfile_ElementGeneralProperties___default.a, ElementDefinition: __WEBPACK_IMPORTED_MODULE_8__ElementDefinition___default.a, ElementBadge: __WEBPACK_IMPORTED_MODULE_7__ElementBadge___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    elements: 'localizedElements'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    gameState: function gameState(state) {
      return state.game.state;
    }
  }), {
    selectedElement: function selectedElement() {
      return this.elements[this.selectedElementId] || {};
    },
    isGameRunning: function isGameRunning() {
      return this.gameState === __WEBPACK_IMPORTED_MODULE_6__store_modules_game__["b" /* gameStates */].IS_RUNNING;
    }
  }),
  data: function data() {
    return {
      duration: 12,
      gameInput: '',
      filteredElements: [],
      gameStates: __WEBPACK_IMPORTED_MODULE_6__store_modules_game__["b" /* gameStates */].IS_RUNNING
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5__shared_bus__["a" /* bus */].$on('game:over', function () {
      console.log('bus: game:over');
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["c" /* UPDATE_GAME_STATE */], __WEBPACK_IMPORTED_MODULE_6__store_modules_game__["b" /* gameStates */].IS_NOT_RUNNING);
    });

    if (this.isGameRunning) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["c" /* UPDATE_GAME_STATE */], __WEBPACK_IMPORTED_MODULE_6__store_modules_game__["b" /* gameStates */].IS_NOT_RUNNING);
    }
  },

  methods: {
    filteredElementsContainElementsOfGroup: function filteredElementsContainElementsOfGroup(group) {
      var filteredElementsContainElementsOfGroup = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.filteredElements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var id = _step.value;

          if (this.elements[id].elementGroup === group) {
            filteredElementsContainElementsOfGroup = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return filteredElementsContainElementsOfGroup;
    },
    resetGameState: function resetGameState() {
      this.gameInput = '';

      if (this.gameState !== __WEBPACK_IMPORTED_MODULE_6__store_modules_game__["b" /* gameStates */].IS_NOT_RUNNING) {
        this.filteredElements = [];
      }
    }
  },
  watch: {
    gameInput: function gameInput() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.elements)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var element = _step2.value;

          if (this.elements[element].name.toLowerCase() === this.gameInput.toLowerCase()) {
            if (this.filteredElements.indexOf(+element) === -1) {
              this.filteredElements.push(+element);
              this.gameInput = '';

              if (this.filteredElements.length === 118) {
                this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["c" /* UPDATE_GAME_STATE */], __WEBPACK_IMPORTED_MODULE_6__store_modules_game__["b" /* gameStates */].IS_NOT_RUNNING);
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    gameState: function gameState() {
      this.resetGameState();
    }
  }
});

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementProfile__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PeriodicTable__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PeriodicTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PeriodicTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_LanguageSwitcher__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_LanguageSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_2__shared_LanguageSwitcher___default.a, PeriodicTable: __WEBPACK_IMPORTED_MODULE_1__PeriodicTable___default.a, ElementProfile: __WEBPACK_IMPORTED_MODULE_0__ElementProfile___default.a
  },
  computed: {
    search: {
      get: function get() {
        return this.$store.state.filters.search;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["d" /* UPDATE_SEARCH */], value);
      }
    }
  },
  data: function data() {
    return {
      msg: 'Mendelable',
      isMenuOpened: false,
      githubLink: 'https://github.com/pulsardev/mendelable'
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isMenuOpened = !this.isMenuOpened;
    },
    trackClick: function trackClick(destination, eventCategory) {
      window.ga('send', 'event', eventCategory, 'click', destination);
    }
  }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElementBadge__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElementBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ElementBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ElementDefinition__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ElementDefinition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ElementDefinition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ElementProfile_ElementGeneralProperties__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ElementProfile_ElementGeneralProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ElementProfile_ElementGeneralProperties__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'periodic-table',
  components: {
    ElementGeneralProperties: __WEBPACK_IMPORTED_MODULE_5__ElementProfile_ElementGeneralProperties___default.a, ElementDefinition: __WEBPACK_IMPORTED_MODULE_4__ElementDefinition___default.a, ElementBadge: __WEBPACK_IMPORTED_MODULE_3__ElementBadge___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    elements: 'localizedElements',
    filteredElements: 'filteredElements'
  }), {
    selectedElement: function selectedElement() {
      return this.elements[this.selectedElementId] || {};
    }
  }),
  data: function data() {
    return {
      selectedElementId: '',
      showInfo: false
    };
  },

  methods: {
    showElement: function showElement(element) {
      this.showInfo = true;
      this.selectedElementId = element.atomicNumber;
    },
    hideElement: function hideElement() {
      this.showInfo = false;
    },
    filteredElementsContainElementsOfGroup: function filteredElementsContainElementsOfGroup(group) {
      var filteredElementsContainElementsOfGroup = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.filteredElements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var id = _step.value;

          if (this.elements[id].elementGroup === group) {
            filteredElementsContainElementsOfGroup = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return filteredElementsContainElementsOfGroup;
    }
  }
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_MaterialComponents_MdcSwitch__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_MaterialComponents_MdcSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shared_MaterialComponents_MdcSwitch__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'element-profile-options',
  components: {
    MdcSwitch: __WEBPACK_IMPORTED_MODULE_4__shared_MaterialComponents_MdcSwitch___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    numberOfElements: function numberOfElements(state) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.elements.default).length;
    }
  }), {
    previousElementId: function previousElementId() {
      return +this.$route.params.id - 1;
    },
    nextElementId: function nextElementId() {
      return +this.$route.params.id + 1;
    },

    debug: {
      get: function get() {
        return this.$store.state.configuration.debug;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["a" /* TOGGLE_DEBUG */], value);
      }
    }
  })
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_game__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PeriodicTableOptions__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PeriodicTableOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PeriodicTableOptions__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'game-mode-options',
  components: {
    PeriodicTableOptions: __WEBPACK_IMPORTED_MODULE_4__PeriodicTableOptions___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    gameState: function gameState(state) {
      return state.game.state;
    }
  }), {
    isGameRunning: function isGameRunning() {
      return this.gameState === __WEBPACK_IMPORTED_MODULE_3__store_modules_game__["b" /* gameStates */].IS_RUNNING;
    }
  }),
  methods: {
    startGame: function startGame() {
      this.trackClick('game:start');
      window.scrollTo(0, 0);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["c" /* UPDATE_GAME_STATE */], __WEBPACK_IMPORTED_MODULE_3__store_modules_game__["b" /* gameStates */].IS_RUNNING);
    },
    stopGame: function stopGame() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["c" /* UPDATE_GAME_STATE */], __WEBPACK_IMPORTED_MODULE_3__store_modules_game__["b" /* gameStates */].IS_NOT_RUNNING);
    },
    trackClick: function trackClick(destination) {
      window.ga('send', 'event', 'inbound', 'click', destination);
    }
  }
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_MaterialComponents_MdcSwitch__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_MaterialComponents_MdcSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_MaterialComponents_MdcSwitch__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'periodic-table-options',
  components: {
    MdcSwitch: __WEBPACK_IMPORTED_MODULE_1__shared_MaterialComponents_MdcSwitch___default.a
  },
  data: function data() {
    return {
      groups: ['non-metal', 'halogen', 'metalloid', 'metal', 'alkali-metal', 'alkaline-earth-metal', 'transition-metal', 'noble-gas', 'lanthanoid', 'actinoid']
    };
  },

  methods: {
    addGroupOnHover: function addGroupOnHover(group) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["e" /* ADD_GROUP */], group);
    },
    removeGroupOnHover: function removeGroupOnHover(group) {
      var _this = this;

      setTimeout(function () {
        return _this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["f" /* REMOVE_GROUP */], group);
      }, 125);
    }
  },
  computed: {
    simpleView: {
      get: function get() {
        return this.$store.state.configuration.simpleView;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["b" /* TOGGLE_SIMPLE_VIEW */], value);
      }
    }
  }
});

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bar-chart',
  props: ['element'],
  mounted: function mounted() {
    this.renderChart();
  },
  watch: {
    element: function element() {
      this.renderChart();
    }
  },
  methods: {
    renderChart: function renderChart() {
      var data = [];

      data.push(Math.round(this.element.boilingPoint['C'] + 273.15));
      data.push(Math.round(this.element.meltingPoint['C'] + 273.15));

      var ctx = this.$refs['c-chart'];

      new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
        type: 'bar',
        data: {
          labels: [this.$t('element.boilingPoint'), this.$t('element.meltingPoint')],
          datasets: [{
            label: this.$t('general.temperature') + ' (°K)',
            data: data,
            backgroundColor: ['rgba(244, 67, 54, 1)', 'rgba(239, 187, 49, 1)'],
            borderWidth: 0
          }]
        },
        options: {
          responsive: true,
          scales: {
            xAxes: [{
              barThickness: 5,
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                fontColor: 'white',
                maxRotation: 0
              }
            }],
            yAxes: [{
              scaleLabel: {
                fontColor: 'white'
              },
              gridLines: {
                color: 'rgba(255,255,255,0.05)',
                drawBorder: false
              },
              ticks: {
                beginAtZero: true,
                padding: 16
              }
            }]
          },
          legend: {
            display: false,
            labels: {
              fontColor: 'white',
              boxWidth: 0
            },
            position: 'bottom'
          }
        }
      });
    }
  }
});

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_bus__ = __webpack_require__(42);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('twoDigits', function (value) {
  if (value.toString().length <= 1) {
    return '0' + value.toString();
  }
  return value.toString();
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'countdown',
  props: ['duration', 'durationUnit', 'play'],
  data: function data() {
    return {
      elapsed: 0,
      countdown: 0
    };
  },

  watch: {
    play: function play() {
      var _this = this;

      if (this.play) {
        this.countdown = setInterval(function () {
          if (_this.elapsed === __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(_this.duration, _this.durationUnit).asSeconds()) {
            clearInterval(_this.countdown);
            __WEBPACK_IMPORTED_MODULE_2__shared_bus__["a" /* bus */].$emit('game:over');
          } else {
            _this.elapsed++;
          }
        }, 1000);
      } else {
        clearInterval(this.countdown);
        this.elapsed = 0;
      }
    }
  },
  computed: {
    seconds: function seconds() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(this.duration, this.durationUnit).subtract(this.elapsed, 'seconds').seconds();
    },
    minutes: function minutes() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(this.duration, this.durationUnit).subtract(this.elapsed, 'seconds').minutes();
    }
  }
});

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doughnut-chart',
  props: ['element'],
  mounted: function mounted() {
    this.renderChart();
  },
  watch: {
    element: function element() {
      this.renderChart();
    }
  },
  methods: {
    renderChart: function renderChart() {
      var backgroundColors = ['rgba(3, 169, 244, 1)', 'rgba(239, 187, 49, 1)', 'rgba(25, 202, 167, 1)', 'rgba(244, 67, 54, 1)', 'rgba(103, 58, 183, 1)', 'rgba(53, 64, 77, 1)'];

      var baseData = [0, 0, 0, 0, 0, 0];
      var shells = {
        k: { array: baseData.slice(), maxElectrons: 2, index: 0 },
        l: { array: baseData.slice(), maxElectrons: 8, index: 1 },
        m: { array: baseData.slice(), maxElectrons: 18, index: 2 },
        n: { array: baseData.slice(), maxElectrons: 32, index: 3 },
        o: { array: baseData.slice(), maxElectrons: 50, index: 4 }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(shells)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var shell = _step.value;

          var shellIndex = shells[shell].index;
          var numberOfElectrons = this.element.electronsPerShell[shellIndex];

          if (this.element.electronsPerShell[shellIndex]) {
            shells[shell].array[shellIndex] = numberOfElectrons;
            shells[shell].array[5] = shells[shell].maxElectrons - numberOfElectrons;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var ctx = this.$refs['doughnut-chart'];

      new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, {
        type: 'doughnut',
        data: {
          labels: ['K', 'L', 'M', 'N', 'O', ''],
          datasets: [{
            data: baseData,
            backgroundColor: backgroundColors,
            borderWidth: 0,
            borderColor: '#1f2731'
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: shells['o'].array,
            backgroundColor: backgroundColors,
            borderWidth: 0,
            borderColor: '#1f2731'
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: shells['n'].array,
            backgroundColor: backgroundColors,
            borderWidth: 0,
            borderColor: '#1f2731'
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: shells['m'].array,
            backgroundColor: backgroundColors,
            borderWidth: 0,
            borderColor: '#1f2731'
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: [0],
            borderWidth: 0
          }, {
            data: shells['l'].array,
            backgroundColor: backgroundColors,
            borderWidth: 0,
            borderColor: '#1f2731'
          }, {
            data: shells['k'].array,
            backgroundColor: backgroundColors,
            borderWidth: 0,
            borderColor: '#1f2731'
          }]
        },
        options: {
          responsive: true,
          cutoutPercentage: 0,
          rotation: Math.PI,
          legend: {
            display: true,
            labels: {
              fontColor: 'white',
              usePointStyle: true
            },
            position: 'bottom'
          }
        }
      });
    }
  }
});

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highlight_js__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highlight_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'highlight',
  props: ['data'],
  mounted: function mounted() {
    this.highlight();
  },
  watch: {
    data: function data() {
      this.highlight();
    }
  },
  methods: {
    highlight: function highlight() {
      var ctx = this.$refs['c-highlight'];
      ctx.textContent = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data, null, 2);
      __WEBPACK_IMPORTED_MODULE_1_highlight_js___default.a.highlightBlock(ctx);
    }
  }
});

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'language-switcher',
  data: function data() {
    return {
      selected: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].locale,
      options: [{ text: 'English', value: 'en_US' }, { text: 'Français', value: 'fr_FR' }, { text: 'Türkçe', value: 'tr_TR' }]
    };
  },

  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapActions */])(['changeLanguage'])
});

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chart_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_colors__ = __webpack_require__(304);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'line-chart',
  props: ['element'],
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    elements: 'localizedElements'
  }),
  mounted: function mounted() {
    this.renderChart();
  },
  watch: {
    element: function element() {
      this.renderChart();
    }
  },
  methods: {
    renderChart: function renderChart() {
      var _this = this;

      var elements = this.elements;

      var data = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(elements)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var element = elements[key];

          if (element.ionizationEnergy !== 0) {
            data.push({
              x: element.atomicNumber,
              y: element.ionizationEnergy
            });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var ctx = this.$refs['c-line-chart'];

      new __WEBPACK_IMPORTED_MODULE_3_chart_js___default.a(ctx, {
        type: 'line',
        data: {
          labels: this.$t('element.ionizationEnergy'),
          datasets: [{
            label: this.$t('element.ionizationEnergy'),
            data: [{
              x: this.element.atomicNumber,
              y: this.element.ionizationEnergy
            }],
            pointBorderWidth: 10,
            pointBorderColor: 'rgba(255, 255, 255, 0.25)',
            pointBackgroundColor: 'rgba(255, 255, 255, 1)'
          }, {
            label: this.$t('element.ionizationEnergy'),
            data: data,
            backgroundColor: ['rgba(' + __WEBPACK_IMPORTED_MODULE_4__shared_colors__["a" /* colors */][this.element.elementGroup] + ', 0.1)'],
            showLine: true,
            borderColor: 'rgba(' + __WEBPACK_IMPORTED_MODULE_4__shared_colors__["a" /* colors */][this.element.elementGroup] + ', 0.5)',
            borderWidth: 2,
            pointBorderWidth: 0,
            pointBackgroundColor: 'rgba(' + __WEBPACK_IMPORTED_MODULE_4__shared_colors__["a" /* colors */][this.element.elementGroup] + ', 1)',
            pointRadius: 2,
            borderJoinStyle: 'round',
            lineTension: 0
          }]
        },
        options: {
          responsive: true,
          legend: {
            labels: {
              boxWidth: 0,
              fontColor: 'transparent'
            }
          },
          tooltips: {
            callbacks: {
              title: function title(tooltipItem, data) {
                return _this.elements[(tooltipItem[0].index + 1).toString()].name;
              }
            }
          },
          scales: {
            xAxes: [{
              type: 'linear',
              position: 'bottom',
              gridLines: {
                display: false,
                drawBorder: false,
                tickMarkLength: 0
              },
              ticks: {
                beginAtZero: false,
                min: 1,
                max: 103,
                display: false
              }
            }],
            yAxes: [{
              gridLines: {
                display: false,
                drawBorder: false,
                tickMarkLength: 0
              },
              ticks: {
                display: false
              }
            }]
          }
        }
      });
    }
  }
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mdc-switch',
  props: ['value'],
  methods: {
    update: function update(e) {
      this.$emit('input', e.target.value);
    }
  }
});

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 43,
	"./af.js": 43,
	"./ar": 50,
	"./ar-dz": 44,
	"./ar-dz.js": 44,
	"./ar-kw": 45,
	"./ar-kw.js": 45,
	"./ar-ly": 46,
	"./ar-ly.js": 46,
	"./ar-ma": 47,
	"./ar-ma.js": 47,
	"./ar-sa": 48,
	"./ar-sa.js": 48,
	"./ar-tn": 49,
	"./ar-tn.js": 49,
	"./ar.js": 50,
	"./az": 51,
	"./az.js": 51,
	"./be": 52,
	"./be.js": 52,
	"./bg": 53,
	"./bg.js": 53,
	"./bn": 54,
	"./bn.js": 54,
	"./bo": 55,
	"./bo.js": 55,
	"./br": 56,
	"./br.js": 56,
	"./bs": 57,
	"./bs.js": 57,
	"./ca": 58,
	"./ca.js": 58,
	"./cs": 59,
	"./cs.js": 59,
	"./cv": 60,
	"./cv.js": 60,
	"./cy": 61,
	"./cy.js": 61,
	"./da": 62,
	"./da.js": 62,
	"./de": 65,
	"./de-at": 63,
	"./de-at.js": 63,
	"./de-ch": 64,
	"./de-ch.js": 64,
	"./de.js": 65,
	"./dv": 66,
	"./dv.js": 66,
	"./el": 67,
	"./el.js": 67,
	"./en-au": 68,
	"./en-au.js": 68,
	"./en-ca": 69,
	"./en-ca.js": 69,
	"./en-gb": 70,
	"./en-gb.js": 70,
	"./en-ie": 71,
	"./en-ie.js": 71,
	"./en-nz": 72,
	"./en-nz.js": 72,
	"./eo": 73,
	"./eo.js": 73,
	"./es": 75,
	"./es-do": 74,
	"./es-do.js": 74,
	"./es.js": 75,
	"./et": 76,
	"./et.js": 76,
	"./eu": 77,
	"./eu.js": 77,
	"./fa": 78,
	"./fa.js": 78,
	"./fi": 79,
	"./fi.js": 79,
	"./fo": 80,
	"./fo.js": 80,
	"./fr": 83,
	"./fr-ca": 81,
	"./fr-ca.js": 81,
	"./fr-ch": 82,
	"./fr-ch.js": 82,
	"./fr.js": 83,
	"./fy": 84,
	"./fy.js": 84,
	"./gd": 85,
	"./gd.js": 85,
	"./gl": 86,
	"./gl.js": 86,
	"./gom-latn": 87,
	"./gom-latn.js": 87,
	"./he": 88,
	"./he.js": 88,
	"./hi": 89,
	"./hi.js": 89,
	"./hr": 90,
	"./hr.js": 90,
	"./hu": 91,
	"./hu.js": 91,
	"./hy-am": 92,
	"./hy-am.js": 92,
	"./id": 93,
	"./id.js": 93,
	"./is": 94,
	"./is.js": 94,
	"./it": 95,
	"./it.js": 95,
	"./ja": 96,
	"./ja.js": 96,
	"./jv": 97,
	"./jv.js": 97,
	"./ka": 98,
	"./ka.js": 98,
	"./kk": 99,
	"./kk.js": 99,
	"./km": 100,
	"./km.js": 100,
	"./kn": 101,
	"./kn.js": 101,
	"./ko": 102,
	"./ko.js": 102,
	"./ky": 103,
	"./ky.js": 103,
	"./lb": 104,
	"./lb.js": 104,
	"./lo": 105,
	"./lo.js": 105,
	"./lt": 106,
	"./lt.js": 106,
	"./lv": 107,
	"./lv.js": 107,
	"./me": 108,
	"./me.js": 108,
	"./mi": 109,
	"./mi.js": 109,
	"./mk": 110,
	"./mk.js": 110,
	"./ml": 111,
	"./ml.js": 111,
	"./mr": 112,
	"./mr.js": 112,
	"./ms": 114,
	"./ms-my": 113,
	"./ms-my.js": 113,
	"./ms.js": 114,
	"./my": 115,
	"./my.js": 115,
	"./nb": 116,
	"./nb.js": 116,
	"./ne": 117,
	"./ne.js": 117,
	"./nl": 119,
	"./nl-be": 118,
	"./nl-be.js": 118,
	"./nl.js": 119,
	"./nn": 120,
	"./nn.js": 120,
	"./pa-in": 121,
	"./pa-in.js": 121,
	"./pl": 122,
	"./pl.js": 122,
	"./pt": 124,
	"./pt-br": 123,
	"./pt-br.js": 123,
	"./pt.js": 124,
	"./ro": 125,
	"./ro.js": 125,
	"./ru": 126,
	"./ru.js": 126,
	"./sd": 127,
	"./sd.js": 127,
	"./se": 128,
	"./se.js": 128,
	"./si": 129,
	"./si.js": 129,
	"./sk": 130,
	"./sk.js": 130,
	"./sl": 131,
	"./sl.js": 131,
	"./sq": 132,
	"./sq.js": 132,
	"./sr": 134,
	"./sr-cyrl": 133,
	"./sr-cyrl.js": 133,
	"./sr.js": 134,
	"./ss": 135,
	"./ss.js": 135,
	"./sv": 136,
	"./sv.js": 136,
	"./sw": 137,
	"./sw.js": 137,
	"./ta": 138,
	"./ta.js": 138,
	"./te": 139,
	"./te.js": 139,
	"./tet": 140,
	"./tet.js": 140,
	"./th": 141,
	"./th.js": 141,
	"./tl-ph": 142,
	"./tl-ph.js": 142,
	"./tlh": 143,
	"./tlh.js": 143,
	"./tr": 144,
	"./tr.js": 144,
	"./tzl": 145,
	"./tzl.js": 145,
	"./tzm": 147,
	"./tzm-latn": 146,
	"./tzm-latn.js": 146,
	"./tzm.js": 147,
	"./uk": 148,
	"./uk.js": 148,
	"./ur": 149,
	"./ur.js": 149,
	"./uz": 151,
	"./uz-latn": 150,
	"./uz-latn.js": 150,
	"./uz.js": 151,
	"./vi": 152,
	"./vi.js": 152,
	"./x-pseudo": 153,
	"./x-pseudo.js": 153,
	"./yo": 154,
	"./yo.js": 154,
	"./zh-cn": 155,
	"./zh-cn.js": 155,
	"./zh-hk": 156,
	"./zh-hk.js": 156,
	"./zh-tw": 157,
	"./zh-tw.js": 157
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 337;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(430)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  "data-v-6517a1fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  "data-v-4aea75d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_counters__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_elements__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_language__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_filters__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_game__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_configuration__ = __webpack_require__(307);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  modules: {
    counters: __WEBPACK_IMPORTED_MODULE_4__modules_counters__["a" /* default */],
    elements: __WEBPACK_IMPORTED_MODULE_5__modules_elements__["a" /* default */],
    language: __WEBPACK_IMPORTED_MODULE_6__modules_language__["a" /* default */],
    filters: __WEBPACK_IMPORTED_MODULE_7__modules_filters__["a" /* default */],
    game: __WEBPACK_IMPORTED_MODULE_8__modules_game__["a" /* default */],
    configuration: __WEBPACK_IMPORTED_MODULE_9__modules_configuration__["a" /* default */]
  },
  strict: debug
}));

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DECREMENT_MAIN_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return INCREMENT_MAIN_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REMOVE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_GAME_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_DEBUG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_SIMPLE_VIEW; });
var DECREMENT_MAIN_COUNTER = 'DECREMENT_MAIN_COUNTER';
var INCREMENT_MAIN_COUNTER = 'INCREMENT_MAIN_COUNTER';

var UPDATE_LOCALE = 'UPDATE_LOCALE';

var UPDATE_SEARCH = 'UPDATE_SEARCH';
var ADD_GROUP = 'ADD_GROUP';
var REMOVE_GROUP = 'REMOVE_GROUP';

var UPDATE_GAME_STATE = 'UPDATE_GAME_STATE';

var TOGGLE_DEBUG = 'TOGGLE_DEBUG';
var TOGGLE_SIMPLE_VIEW = 'TOGGLE_SIMPLE_VIEW';

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 171,
	"./af.js": 171,
	"./ar": 178,
	"./ar-dz": 172,
	"./ar-dz.js": 172,
	"./ar-kw": 173,
	"./ar-kw.js": 173,
	"./ar-ly": 174,
	"./ar-ly.js": 174,
	"./ar-ma": 175,
	"./ar-ma.js": 175,
	"./ar-sa": 176,
	"./ar-sa.js": 176,
	"./ar-tn": 177,
	"./ar-tn.js": 177,
	"./ar.js": 178,
	"./az": 179,
	"./az.js": 179,
	"./be": 180,
	"./be.js": 180,
	"./bg": 181,
	"./bg.js": 181,
	"./bm": 182,
	"./bm.js": 182,
	"./bn": 183,
	"./bn.js": 183,
	"./bo": 184,
	"./bo.js": 184,
	"./br": 185,
	"./br.js": 185,
	"./bs": 186,
	"./bs.js": 186,
	"./ca": 187,
	"./ca.js": 187,
	"./cs": 188,
	"./cs.js": 188,
	"./cv": 189,
	"./cv.js": 189,
	"./cy": 190,
	"./cy.js": 190,
	"./da": 191,
	"./da.js": 191,
	"./de": 194,
	"./de-at": 192,
	"./de-at.js": 192,
	"./de-ch": 193,
	"./de-ch.js": 193,
	"./de.js": 194,
	"./dv": 195,
	"./dv.js": 195,
	"./el": 196,
	"./el.js": 196,
	"./en-au": 197,
	"./en-au.js": 197,
	"./en-ca": 198,
	"./en-ca.js": 198,
	"./en-gb": 199,
	"./en-gb.js": 199,
	"./en-ie": 200,
	"./en-ie.js": 200,
	"./en-nz": 201,
	"./en-nz.js": 201,
	"./eo": 202,
	"./eo.js": 202,
	"./es": 205,
	"./es-do": 203,
	"./es-do.js": 203,
	"./es-us": 204,
	"./es-us.js": 204,
	"./es.js": 205,
	"./et": 206,
	"./et.js": 206,
	"./eu": 207,
	"./eu.js": 207,
	"./fa": 208,
	"./fa.js": 208,
	"./fi": 209,
	"./fi.js": 209,
	"./fo": 210,
	"./fo.js": 210,
	"./fr": 213,
	"./fr-ca": 211,
	"./fr-ca.js": 211,
	"./fr-ch": 212,
	"./fr-ch.js": 212,
	"./fr.js": 213,
	"./fy": 214,
	"./fy.js": 214,
	"./gd": 215,
	"./gd.js": 215,
	"./gl": 216,
	"./gl.js": 216,
	"./gom-latn": 217,
	"./gom-latn.js": 217,
	"./gu": 218,
	"./gu.js": 218,
	"./he": 219,
	"./he.js": 219,
	"./hi": 220,
	"./hi.js": 220,
	"./hr": 221,
	"./hr.js": 221,
	"./hu": 222,
	"./hu.js": 222,
	"./hy-am": 223,
	"./hy-am.js": 223,
	"./id": 224,
	"./id.js": 224,
	"./is": 225,
	"./is.js": 225,
	"./it": 226,
	"./it.js": 226,
	"./ja": 227,
	"./ja.js": 227,
	"./jv": 228,
	"./jv.js": 228,
	"./ka": 229,
	"./ka.js": 229,
	"./kk": 230,
	"./kk.js": 230,
	"./km": 231,
	"./km.js": 231,
	"./kn": 232,
	"./kn.js": 232,
	"./ko": 233,
	"./ko.js": 233,
	"./ky": 234,
	"./ky.js": 234,
	"./lb": 235,
	"./lb.js": 235,
	"./lo": 236,
	"./lo.js": 236,
	"./lt": 237,
	"./lt.js": 237,
	"./lv": 238,
	"./lv.js": 238,
	"./me": 239,
	"./me.js": 239,
	"./mi": 240,
	"./mi.js": 240,
	"./mk": 241,
	"./mk.js": 241,
	"./ml": 242,
	"./ml.js": 242,
	"./mr": 243,
	"./mr.js": 243,
	"./ms": 245,
	"./ms-my": 244,
	"./ms-my.js": 244,
	"./ms.js": 245,
	"./my": 246,
	"./my.js": 246,
	"./nb": 247,
	"./nb.js": 247,
	"./ne": 248,
	"./ne.js": 248,
	"./nl": 250,
	"./nl-be": 249,
	"./nl-be.js": 249,
	"./nl.js": 250,
	"./nn": 251,
	"./nn.js": 251,
	"./pa-in": 252,
	"./pa-in.js": 252,
	"./pl": 253,
	"./pl.js": 253,
	"./pt": 255,
	"./pt-br": 254,
	"./pt-br.js": 254,
	"./pt.js": 255,
	"./ro": 256,
	"./ro.js": 256,
	"./ru": 257,
	"./ru.js": 257,
	"./sd": 258,
	"./sd.js": 258,
	"./se": 259,
	"./se.js": 259,
	"./si": 260,
	"./si.js": 260,
	"./sk": 261,
	"./sk.js": 261,
	"./sl": 262,
	"./sl.js": 262,
	"./sq": 263,
	"./sq.js": 263,
	"./sr": 265,
	"./sr-cyrl": 264,
	"./sr-cyrl.js": 264,
	"./sr.js": 265,
	"./ss": 266,
	"./ss.js": 266,
	"./sv": 267,
	"./sv.js": 267,
	"./sw": 268,
	"./sw.js": 268,
	"./ta": 269,
	"./ta.js": 269,
	"./te": 270,
	"./te.js": 270,
	"./tet": 271,
	"./tet.js": 271,
	"./th": 272,
	"./th.js": 272,
	"./tl-ph": 273,
	"./tl-ph.js": 273,
	"./tlh": 274,
	"./tlh.js": 274,
	"./tr": 275,
	"./tr.js": 275,
	"./tzl": 276,
	"./tzl.js": 276,
	"./tzm": 278,
	"./tzm-latn": 277,
	"./tzm-latn.js": 277,
	"./tzm.js": 278,
	"./uk": 279,
	"./uk.js": 279,
	"./ur": 280,
	"./ur.js": 280,
	"./uz": 282,
	"./uz-latn": 281,
	"./uz-latn.js": 281,
	"./uz.js": 282,
	"./vi": 283,
	"./vi.js": 283,
	"./x-pseudo": 284,
	"./x-pseudo.js": 284,
	"./yo": 285,
	"./yo.js": 285,
	"./zh-cn": 286,
	"./zh-cn.js": 286,
	"./zh-hk": 287,
	"./zh-hk.js": 287,
	"./zh-tw": 288,
	"./zh-tw.js": 288
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 617;

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.e72bbd3.jpg";

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(433)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  "data-v-84e8729a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  "data-v-60e35ed1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(431)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  "data-v-75601ffb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  "data-v-458c3852",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  "data-v-4a2b8c3a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  "data-v-1be176e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 634:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-element-badge",
    class: _vm.element.elementGroup && _vm.element.elementGroup.toLowerCase()
  }, [_c('element-definition', {
    attrs: {
      "element": _vm.element
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    ref: "c-highlight",
    staticClass: "json"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-periodic-table"
  }, [_c('element-general-properties', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (Object.keys(_vm.selectedElement).length > 0),
      expression: "Object.keys(selectedElement).length > 0"
    }],
    staticClass: "c-information",
    attrs: {
      "element": _vm.selectedElement,
      "preview": true
    }
  }), _vm._v(" "), _vm._l((_vm.elements), function(element) {
    return _c('div', {
      staticClass: "element",
      class: element.symbol && element.symbol.toLowerCase(),
      style: ({
        opacity: _vm.filteredElements.includes(element.atomicNumber) ? 1 : 0.25
      }),
      attrs: {
        "data-element-group": element.elementGroup,
        "data-group": element.group,
        "data-period": element.period
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/element/' + element.atomicNumber
      },
      nativeOn: {
        "mouseover": function($event) {
          _vm.showElement(element)
        },
        "mouseout": function($event) {
          _vm.hideElement()
        }
      }
    }, [_c('element-definition', {
      staticClass: "u-aspect-ratio",
      attrs: {
        "element": element,
        "detailed": true
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "element lanthanoid",
    style: ({
      opacity: _vm.filteredElementsContainElementsOfGroup('lanthanoid') ? 1 : 0.25
    }),
    attrs: {
      "data-element-group": "lanthanoid"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "element actinoid",
    style: ({
      opacity: _vm.filteredElementsContainElementsOfGroup('actinoid') ? 1 : 0.25
    }),
    attrs: {
      "data-element-group": "actinoid"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-element-profile"
  }, [_c('div', {
    ref: "c-masonry-grid",
    staticClass: "c-masonry-grid"
  }, [_c('div', {
    staticClass: "c-masonry-grid__sizer"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-masonry-grid__item c-masonry-grid__item--width-75"
  }, [_c('element-general-properties', {
    attrs: {
      "element": _vm.element
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-masonry-grid__item"
  }, [_c('element-atomic-properties', {
    attrs: {
      "element": _vm.element
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-masonry-grid__item"
  }, [(_vm.element.boilingPoint && _vm.element.boilingPoint['C'] && _vm.element.meltingPoint && _vm.element.meltingPoint['C']) ? _c('div', {
    staticClass: "card"
  }, [(Object.keys(_vm.element).length > 0) ? _c('div', {
    staticClass: "card-block"
  }, [_c('h6', {
    staticClass: "card-title text-uppercase font-weight-bold"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("element.physicalProperties")))])]), _vm._v(" "), _c('bar-chart', {
    staticClass: "mt-5",
    attrs: {
      "element": _vm.element
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-masonry-grid__item c-masonry-grid__item--width-100"
  }, [_c('element-historical-properties', {
    attrs: {
      "element": _vm.element
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-element-profile-options"
  }, [_c('div', {
    staticClass: "btn-group w-100",
    attrs: {
      "role": "group",
      "aria-label": "Navigation"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "to": '/element/' + _vm.previousElementId,
      "tag": "button",
      "type": "button",
      "disabled": _vm.previousElementId === 0
    }
  }, [_vm._v(_vm._s(_vm.$t("sidebar.elementProfile.previous")))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "to": '/element/' + _vm.nextElementId,
      "tag": "button",
      "type": "button",
      "disabled": _vm.nextElementId === _vm.numberOfElements + 1
    }
  }, [_vm._v(_vm._s(_vm.$t("sidebar.elementProfile.next")))])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-3"
  }, [_vm._v("Debug")]), _vm._v(" "), _c('mdc-switch', {
    model: {
      value: (_vm.debug),
      callback: function($$v) {
        _vm.debug = $$v
      },
      expression: "debug"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-countdown"
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.minutes)) + ":" + _vm._s(_vm._f("twoDigits")(_vm.seconds)))])])
},staticRenderFns: []}

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element-general-properties card"
  }, [(Object.keys(_vm.element).length > 0) ? _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col d-flex"
  }, [_c('element-badge', {
    attrs: {
      "element": _vm.element
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.element.name))]), _vm._v(" "), _c('h6', {
    staticClass: "card-subtitle mb-2 text-muted"
  }, [_vm._v(_vm._s(_vm.$t("element.group." + _vm.element.elementGroup)))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('featured-value', {
    staticClass: "col-md-6 mt-4",
    attrs: {
      "value": _vm.element.atomicNumber,
      "title": "element.atomicNumber",
      "element": _vm.element,
      "colored": true
    }
  }), _vm._v(" "), _c('featured-value', {
    staticClass: "col-md-6 mt-4",
    attrs: {
      "value": _vm.element.atomicMass,
      "title": "element.atomicMass",
      "element": _vm.element,
      "colored": true
    }
  })], 1), _vm._v(" "), (!_vm.preview) ? _c('div', [(_vm.debug) ? _c('highlight', {
    attrs: {
      "data": _vm.element
    }
  }) : _vm._e(), _vm._v(" "), _c('line-chart', {
    attrs: {
      "element": _vm.element
    }
  })], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.element.electronsPerShell && Array.isArray(_vm.element.electronsPerShell)) ? _c('div', {
    staticClass: "element-atomic-properties card"
  }, [(Object.keys(_vm.element).length > 0) ? _c('div', {
    staticClass: "card-block"
  }, [_c('h6', {
    staticClass: "card-title text-uppercase font-weight-bold"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("element.electronsPerShell")))])]), _vm._v(" "), _c('doughnut-chart', {
    attrs: {
      "element": _vm.element
    }
  })], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdc-theme--dark"
  }, [_c('div', {
    staticClass: "mdc-switch"
  }, [_c('input', {
    staticClass: "mdc-switch__native-control",
    attrs: {
      "type": "checkbox",
      "id": "basic-switch"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.update
    }
  }), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdc-switch__background"
  }, [_c('div', {
    staticClass: "mdc-switch__knob"
  })])
}]}

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-periodic-table"
  }, [_c('div', {
    staticClass: "c-information d-flex align-items-end"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between w-100"
  }, [_c('countdown', {
    staticClass: "mr-3",
    attrs: {
      "duration": _vm.duration,
      "duration-unit": "minutes",
      "play": _vm.isGameRunning
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gameInput),
      expression: "gameInput"
    }],
    staticClass: "form-control form-control-lg align-self-stretch",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('game.input'),
      "disabled": !_vm.isGameRunning
    },
    domProps: {
      "value": (_vm.gameInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gameInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-3 text-nowrap"
  }, [_vm._v(_vm._s(_vm.filteredElements.length) + "/118"), _c('br'), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('game.elementsFound')))])])], 1)]), _vm._v(" "), _vm._l((_vm.elements), function(element) {
    return _c('div', {
      staticClass: "element",
      class: element.symbol && element.symbol.toLowerCase(),
      style: ({
        opacity: _vm.filteredElements.includes(element.atomicNumber) ? 1 : 0.25
      }),
      attrs: {
        "data-element-group": element.elementGroup,
        "data-group": element.group,
        "data-period": element.period
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/element/' + element.atomicNumber
      }
    }, [(_vm.filteredElements.includes(element.atomicNumber)) ? _c('element-definition', {
      staticClass: "u-aspect-ratio",
      attrs: {
        "element": element,
        "detailed": true
      }
    }) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "element lanthanoid",
    style: ({
      opacity: _vm.filteredElementsContainElementsOfGroup('lanthanoid') ? 1 : 0.25
    }),
    attrs: {
      "data-element-group": "lanthanoid"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "element actinoid",
    style: ({
      opacity: _vm.filteredElementsContainElementsOfGroup('actinoid') ? 1 : 0.25
    }),
    attrs: {
      "data-element-group": "actinoid"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "c-element-definition d-flex flex-column justify-content-between"
  }, [_c('dt', {
    staticClass: "c-element-definition__symbol align-self-center"
  }, [_vm._v(_vm._s(_vm.element.symbol))]), _vm._v(" "), (_vm.detailed) ? _c('dd', {
    staticClass: "c-element-definition__top flex-first d-flex justify-content-between"
  }, [_c('span', {
    staticClass: "c-element-definition__atomic-mass text-truncate"
  }, [(_vm.simpleView) ? _c('span', [_vm._v(_vm._s(_vm.element.atomicMass))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "c-element-definition__atomic-number"
  }, [_vm._v(_vm._s(_vm.element.atomicNumber))])]) : _vm._e(), _vm._v(" "), (_vm.detailed) ? _c('dd', {
    staticClass: "c-element-definition__name text-center text-truncate"
  }, [_vm._v(_vm._s(_vm.element.name))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-about"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("about.title")))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.primaryText'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('about.featuredText')))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('about.helpUsText')))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-warning mb-3",
    attrs: {
      "href": _vm.paypalLink,
      "target": "_blank",
      "rel": "noopener",
      "title": _vm.$t('about.donate')
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.paypalLink)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('about.donate')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-8"
  }, [_c('form', {
    attrs: {
      "action": "https://formspree.io/pulsar.dev.team@gmail.com",
      "method": "POST",
      "name": "sentMessage",
      "id": "contactForm",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.name.label')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": _vm.$t('contact.form.name.label') + '*',
      "id": "name",
      "required": "",
      "data-validation-required-message": _vm.$t('contact.form.name.validation')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block text-danger"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.email.label')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "_replyto",
      "placeholder": _vm.$t('contact.form.email.label') + '*',
      "id": "email",
      "required": "",
      "data-validation-required-message": _vm.$t('contact.form.email.validation')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "emailHelp"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.email.helpText')))]), _vm._v(" "), (_vm.email && !_vm.isValidEmail) ? _c('p', {
    staticClass: "help-block text-danger"
  }, [_vm._v(_vm._s(_vm.$t('contact.form.email.error')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.message.label')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "placeholder": _vm.$t('contact.form.message.label') + '*',
      "id": "message",
      "rows": "5",
      "required": "",
      "data-validation-required-message": _vm.$t('contact.form.message.validation')
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block text-danger"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit()
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.submit')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.smashingmagazine.com/2017/10/css-grid-challenge-2017-winners/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logo__smashing-magazine--white.svg",
      "alt": "Smashing Magazine",
      "width": "128"
    }
  })])
}]}

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home row"
  }, [_c('div', {
    staticClass: "col-12 px-0 d-flex flex-column flex-sm-row"
  }, [_c('div', {
    staticClass: "bg-inverse px-0 py-5"
  }, [_c('ul', {
    staticClass: "nav flex-column"
  }, [_c('li', {
    staticClass: "nav-item hidden-sm-up"
  }, [_c('a', {
    staticClass: "nav-link d-flex justify-content-center",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("menu")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 mt-sm-0",
    class: {
      'hidden-xs-down': !_vm.isMenuOpened
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link d-flex justify-content-center",
    attrs: {
      "to": "/",
      "exact": "",
      "title": "Mendelable"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("home")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item mt-5"
  }, [_c('router-link', {
    staticClass: "nav-link d-flex justify-content-center",
    attrs: {
      "to": "/game",
      "exact": "",
      "title": _vm.$t('home.gameMode')
    }
  }, [_c('i', {
    staticClass: "material-icons md-36",
    on: {
      "click": function($event) {
        _vm.trackClick('game', 'inbound')
      }
    }
  }, [_vm._v("games")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item mt-5"
  }, [_c('router-link', {
    staticClass: "nav-link d-flex justify-content-center",
    attrs: {
      "to": "/about",
      "exact": "",
      "title": _vm.$t('home.about')
    }
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        _vm.trackClick('help', 'inbound')
      }
    }
  }, [_vm._v("help_outline")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid p-0 w-100 d-flex align-items-stretch"
  }, [_c('div', {
    staticClass: "row no-gutters w-100"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-9 col-xl-10 p-5"
  }, [(_vm.$route.name === 'PeriodicTable') ? _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "searchInput",
      "placeholder": _vm.$t('general.search')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3 col-xl-2 bg-faded px-4 py-5"
  }, [_c('a', {
    staticClass: "btn btn-outline-info btn-block mb-5",
    attrs: {
      "href": _vm.githubLink,
      "target": "_blank",
      "rel": "noopener"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.githubLink, 'outbound')
      }
    }
  }, [_vm._v("Fork me on GitHub")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t("sidebar.title")))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t("language.label")))]), _vm._v(" "), _c('language-switcher'), _vm._v(" "), (_vm.$route.name !== 'About') ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t("sidebar.subtitle")))]) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "sidebar"
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', {
    staticClass: "c-featured-value"
  }, [_c('h6', {
    staticClass: "text-muted text-uppercase"
  }, [_c('small', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t(_vm.title)))])]), _vm._v(" "), _c('p', {
    staticClass: "c-featured-value__text",
    class: [_vm.colored ? 'u-color-' + _vm.element.elementGroup : '']
  }, [_vm._v(_vm._s(_vm.value))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element-card card"
  }, [(Object.keys(_vm.element).length > 0) ? _c('div', {
    staticClass: "card-block"
  }, [_c('h6', {
    staticClass: "card-title text-uppercase font-weight-bold"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("history.generalInformation")))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col d-flex align-items-center"
  }, [(_vm.discoveryAuthorImage) ? _c('a', {
    staticClass: "mr-4",
    attrs: {
      "href": _vm.discoveryAuthorImage,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "rounded-circle",
    attrs: {
      "src": _vm.discoveryAuthorImage
    }
  })]) : _vm._e(), _vm._v(" "), _c('featured-value', {
    staticClass: "mr-4",
    attrs: {
      "value": _vm.element.discoveryDate,
      "title": "history.discoveryDate",
      "element": _vm.element,
      "colored": true
    }
  }), _vm._v(" "), (!_vm.element.discoveryDate) ? _c('featured-value', {
    attrs: {
      "value": "???",
      "title": "history.discoveryDate",
      "element": _vm.element,
      "colored": true
    }
  }) : _vm._e(), _vm._v(" "), _c('featured-value', {
    attrs: {
      "value": _vm.element.discoveryAuthor,
      "title": "history.discoveredBy",
      "element": _vm.element
    }
  })], 1)]), _vm._v(" "), (_vm.element.context) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "text-muted mt-3 mb-0"
  }, [_vm._v(_vm._s(_vm.element.context))])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app container-fluid",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-line-chart"
  }, [_c('canvas', {
    ref: "c-line-chart"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doughnut-chart"
  }, [_c('canvas', {
    ref: "doughnut-chart"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-game-mode-options"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-block",
    attrs: {
      "type": "button",
      "disabled": _vm.isGameRunning
    },
    on: {
      "click": _vm.startGame
    }
  }, [_vm._v(_vm._s(_vm.$t("game.play")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-block",
    attrs: {
      "type": "button",
      "disabled": !_vm.isGameRunning
    },
    on: {
      "click": _vm.stopGame
    }
  }, [_vm._v(_vm._s(_vm.$t("game.stop")))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-5"
  }, [_vm._v(_vm._s(_vm.$t("sidebar.legend")))]), _vm._v(" "), _c('periodic-table-options')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-periodic-table-options"
  }, [_vm._l((_vm.groups), function(group) {
    return _c('button', {
      staticClass: "btn btn-primary btn-block",
      class: 'btn-' + group,
      attrs: {
        "type": "button"
      },
      on: {
        "mouseover": function($event) {
          _vm.addGroupOnHover(group)
        },
        "mouseout": function($event) {
          _vm.removeGroupOnHover(group)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("element.group." + group)) + "\n\n  ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-3"
  }, [_vm._v(_vm._s(_vm.$t("sidebar.simpleView")))]), _vm._v(" "), _c('mdc-switch', {
    model: {
      value: (_vm.simpleView),
      callback: function($$v) {
        _vm.simpleView = $$v
      },
      expression: "simpleView"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-chart"
  }, [_c('canvas', {
    ref: "c-chart"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "language-switcher"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "languageSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function (e) { return _vm.changeLanguage(e.target.value); }]
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

module.exports = {"default":{"1":{"atomicMass":1.0079,"atomicNumber":1,"ionizationEnergy":13.5984,"atomicRay":"25","boilingPoint":{"C":-252.879},"criticalPoint":32.938,"group":"1","density":0.08988,"discoveryAuthor":"Henry Cavendish","electronConfiguration":["1s"],"electronegativity":2.2,"electronsPerShell":[1],"elementGroup":"non-metal","heatOfFusion":0.117,"heatOfVaporization":0.3904,"ionisationEnergy":13.598443,"meltingPoint":{"C":-259.16},"molarHeatCapacity":28.836,"name":"Hydrogen","period":1,"phase":"gas","symbol":"H","triplePoint":13.8033,"discoveryDate":1766,"context":"Hydrogen gas was first artificially produced in the early 16th century by the reaction of acids on metals. In 1766–81, Henry Cavendish was the first to recognize that hydrogen gas was a discrete substance, and that it produces water when burned, the property for which it was later named: in Greek, hydrogen means \"water-former\"."},"2":{"atomicMass":4.0026,"atomicNumber":2,"ionizationEnergy":24.5874,"boilingPoint":{"C":-268.928},"group":"18","electronsPerShell":[2],"elementGroup":"noble-gas","meltingPoint":{"C":-272.2},"name":"Helium","period":1,"phase":"gas","symbol":"He","discoveryDate":1895,"context":"Helium is named for the Greek god of the Sun, Helios. It was first detected as an unknown yellow spectral line signature in sunlight during a solar eclipse in 1868 by Georges Rayet, Captain C. T. Haig, Norman R. Pogson, and Lieutenant John Herschel, and was subsequently confirmed by French astronomer Jules Janssen."},"3":{"atomicMass":6.941,"atomicNumber":3,"ionizationEnergy":5.3917,"boilingPoint":{"C":1330},"group":"1","electronsPerShell":[2,1],"elementGroup":"alkali-metal","meltingPoint":{"C":180.5},"name":"Lithium","period":2,"phase":"solid","symbol":"Li","discoveryDate":1817,"context":"Like all alkali metals, lithium is highly reactive and flammable, and is stored in mineral oil. When cut open, it exhibits a metallic luster, but moist air corrodes it quickly to a dull silvery gray, then black tarnish. It never occurs freely in nature, but only in (usually ionic) compounds, such as pegmatitic minerals which were once the main source of Li. Due to its solubility as an ion, it is present in ocean water and is commonly obtained from brines."},"4":{"atomicMass":9.0122,"atomicNumber":4,"ionizationEnergy":9.3227,"boilingPoint":{"C":2469},"group":"2","electronsPerShell":[2,2],"elementGroup":"alkaline-earth-metal","meltingPoint":{"C":1287},"name":"Beryllium","period":2,"phase":"solid","symbol":"Be","discoveryDate":1798,"context":"The mineral beryl, which contains beryllium, has been used at least since the Ptolemaic dynasty of Egypt. In the first century CE, Roman naturalist Pliny the Elder mentioned in his encyclopedia Natural History that beryl and emerald (\"smaragdus\") were similar. The Papyrus Graecus Holmiensis, written in the third or fourth century CE, contains notes on how to prepare artificial emerald and beryl."},"5":{"atomicMass":10.811,"atomicNumber":5,"ionizationEnergy":8.298,"boilingPoint":{"C":3927},"group":"13","elementGroup":"metalloid","meltingPoint":{"C":2076},"name":"Boron","period":2,"phase":"solid","symbol":"B","electronsPerShell":[2,3],"discoveryDate":1808,"context":"Boron is concentrated on Earth by the water-solubility of its more common naturally occurring compounds, the borate minerals. These are mined industrially as evaporites, such as borax and kernite. The largest known boron deposits are in Turkey, the largest producer of boron minerals."},"6":{"atomicMass":12.0107,"atomicNumber":6,"ionizationEnergy":11.2603,"group":"13","electronsPerShell":[2,4],"elementGroup":"non-metal","meltingPoint":{"C":2349},"name":"Carbon","period":2,"phase":"solid","sublimationPoint":{"C":3642},"symbol":"C","context":"The English name carbon comes from the Latin carbo for coal and charcoal, whence also comes the French charbon, meaning charcoal. In German, Dutch and Danish, the names for carbon are Kohlenstoff, koolstof and kulstof respectively, all literally meaning coal-substance."},"7":{"atomicMass":14.0067,"atomicNumber":7,"ionizationEnergy":14.5341,"elementGroup":"non-metal","group":15,"name":"Nitrogen","period":2,"symbol":"N","electronsPerShell":[2,5],"discoveryDate":1772,"context":"Apart from its use in fertilisers and energy-stores, nitrogen is a constituent of organic compounds as diverse as Kevlar used in high-strength fabric and cyanoacrylate used in superglue. Nitrogen is a constituent of every major pharmacological drug class, including antibiotics."},"8":{"atomicMass":15.9994,"atomicNumber":8,"ionizationEnergy":13.6181,"elementGroup":"non-metal","group":16,"name":"Oxygen","period":2,"symbol":"O","electronsPerShell":[2,6],"discoveryDate":1774,"context":"One hundred million tonnes of O2 are extracted from air for industrial uses annually by two primary methods. The most common method is fractional distillation of liquefied air, with N2 distilling as a vapor while O2 is left as a liquid."},"9":{"atomicMass":18.9984,"atomicNumber":9,"ionizationEnergy":17.4228,"elementGroup":"halogen","group":17,"name":"Fluorine","period":2,"symbol":"F","electronsPerShell":[2,7],"discoveryDate":1886,"context":"Fluorocarbon gases are generally greenhouse gases with global-warming potentials 100 to 20,000 times that of carbon dioxide. Organofluorine compounds persist in the environment due to the strength of the carbon–fluorine bond. Fluorine has no known metabolic role in mammals; a few plants synthesize organofluorine poisons that deter herbivores."},"10":{"atomicMass":20.1797,"atomicNumber":10,"ionizationEnergy":6.2657,"elementGroup":"noble-gas","group":18,"name":"Neon","period":2,"symbol":"Ne","electronsPerShell":[2,8],"discoveryDate":1898,"context":"Neon gives a distinct reddish-orange glow when used in low-voltage neon glow lamps, high-voltage discharge tubes and neon advertising signs. The red emission line from neon also causes the well known red light of helium–neon lasers. Neon is used in some plasma tube and refrigerant applications but has few other commercial uses. It is commercially extracted by the fractional distillation of liquid air. Since air is the only source, it is considerably more expensive than helium."},"11":{"atomicMass":22.9897,"atomicNumber":11,"ionizationEnergy":5.1391,"elementGroup":"alkali-metal","group":1,"name":"Sodium","period":3,"symbol":"Na","electronsPerShell":[2,8,1],"discoveryDate":1807,"context":"Sodium is an essential element for all animals and some plants. Sodium ions are the major cation in the extracellular fluid (ECF) and as such are the major contributor to the ECF osmotic pressure and ECF compartment volume. Loss of water from the ECF compartment increases the sodium concentration, a condition called hypernatremia. Isotonic loss of water and sodium from the ECF compartment decreases the size of that compartment in a condition called ECF hypovolemia."},"12":{"atomicMass":24.305,"atomicNumber":12,"ionizationEnergy":7.6462,"elementGroup":"alkaline-earth-metal","group":2,"name":"Magnesium","period":3,"symbol":"Mg","electronsPerShell":[2,8,2],"discoveryDate":1755,"context":"Magnesium is the eleventh most abundant element by mass in the human body and is essential to all cells and some 300 enzymes. Magnesium ions interact with polyphosphate compounds such as ATP, DNA, and RNA. Hundreds of enzymes require magnesium ions to function. Magnesium compounds are used medicinally as common laxatives, antacids (e.g., milk of magnesia), and to stabilize abnormal nerve excitation or blood vessel spasm in such conditions as eclampsia."},"13":{"atomicMass":26.9815,"atomicNumber":13,"ionizationEnergy":5.9858,"elementGroup":"metal","group":13,"name":"Aluminum","period":3,"symbol":"Al","electronsPerShell":[2,8,3],"discoveryDate":1825,"context":"Aluminium is remarkable for the metal's low density and its ability to resist corrosion through the phenomenon of passivation. Aluminium and its alloys are vital to the aerospace industry and important in transportation and structures, such as building facades and window frames. The oxides and sulfates are the most useful compounds of aluminium."},"14":{"atomicMass":28.0855,"atomicNumber":14,"ionizationEnergy":8.1517,"elementGroup":"metalloid","group":14,"name":"Silicon","period":3,"symbol":"Si","electronsPerShell":[2,8,4],"discoveryDate":1823,"context":"Most free silicon is used in the steel refining, aluminium-casting, and fine chemical industries (often to make fumed silica). Even more visibly, the relatively small portion of very highly purified silicon used in semiconductor electronics (< 10%) is essential to integrated circuits — most computers, cell phones, and modern technology depend on it. Silicon is the basis of the widely used synthetic polymers called silicones."},"15":{"atomicMass":30.9738,"atomicNumber":15,"ionizationEnergy":10.4867,"elementGroup":"non-metal","group":15,"name":"Phosphorus","period":3,"symbol":"P","electronsPerShell":[2,8,5],"discoveryDate":1669,"context":"The first form of elemental phosphorus to be produced (white phosphorus, in 1669) emits a faint glow when exposed to oxygen – hence the name, taken from Greek mythology, Φωσφόρος meaning \"light-bearer\" (Latin Lucifer), referring to the \"Morning Star\", the planet Venus (or Mercury)."},"16":{"atomicMass":32.065,"atomicNumber":16,"ionizationEnergy":10.36,"elementGroup":"non-metal","group":16,"name":"Sulfur","period":3,"symbol":"S","electronsPerShell":[2,8,6],"context":"Sulfur is an essential element for all life, but almost always in the form of organosulfur compounds or metal sulfides. Three amino acids (cysteine, cystine, and methionine) and two vitamins (biotin and thiamine) are organosulfur compounds."},"17":{"atomicMass":35.453,"atomicNumber":17,"ionizationEnergy":12.9676,"elementGroup":"halogen","group":17,"name":"Chlorine","period":3,"symbol":"Cl","electronsPerShell":[2,8,7],"discoveryDate":1774,"context":"In the form of chloride ions, chlorine is necessary to all known species of life. Other types of chlorine compounds are rare in living organisms, and artificially produced chlorinated organics range from inert to toxic."},"18":{"atomicMass":39.948,"atomicNumber":18,"ionizationEnergy":15.7596,"elementGroup":"noble-gas","group":18,"name":"Argon","period":3,"symbol":"Ar","electronsPerShell":[2,8,8],"discoveryDate":1894,"context":"The name \"argon\" is derived from the Greek word ἀργόν, neuter singular form of ἀργός meaning \"lazy\" or \"inactive\", as a reference to the fact that the element undergoes almost no chemical reactions."},"19":{"atomicMass":39.0983,"atomicNumber":19,"ionizationEnergy":4.3407,"elementGroup":"alkali-metal","group":1,"name":"Potassium","period":4,"symbol":"K","electronsPerShell":[2,8,8,1],"discoveryDate":1807},"20":{"atomicMass":40.078,"atomicNumber":20,"ionizationEnergy":6.1132,"elementGroup":"alkaline-earth-metal","group":2,"name":"Calcium","period":4,"symbol":"Ca","electronsPerShell":[2,8,8,2],"discoveryDate":1808},"21":{"atomicMass":44.9559,"atomicNumber":21,"ionizationEnergy":6.5615,"elementGroup":"transition-metal","group":3,"name":"Scandium","period":4,"symbol":"Sc","electronsPerShell":[2,8,9,2],"discoveryDate":1879},"22":{"atomicMass":47.867,"atomicNumber":22,"ionizationEnergy":6.8281,"elementGroup":"transition-metal","group":4,"name":"Titanium","period":4,"symbol":"Ti","electronsPerShell":[2,8,10,2],"discoveryDate":1791},"23":{"atomicMass":50.9415,"atomicNumber":23,"ionizationEnergy":6.7462,"elementGroup":"transition-metal","group":5,"name":"Vanadium","period":4,"symbol":"V","electronsPerShell":[2,8,11,2],"discoveryDate":1801},"24":{"atomicMass":51.9961,"atomicNumber":24,"ionizationEnergy":6.7665,"elementGroup":"transition-metal","group":6,"name":"Chromium","period":4,"symbol":"Cr","electronsPerShell":[2,8,13,1],"discoveryDate":1798},"25":{"atomicMass":54.938,"atomicNumber":25,"ionizationEnergy":7.434,"elementGroup":"transition-metal","group":7,"name":"Manganese","period":4,"symbol":"Mn","electronsPerShell":[2,8,13,2],"discoveryDate":1774},"26":{"atomicMass":55.845,"atomicNumber":26,"ionizationEnergy":7.9024,"elementGroup":"transition-metal","group":8,"name":"Iron","period":4,"symbol":"Fe","electronsPerShell":[2,8,14,2],"discoveryDate":-2500},"27":{"atomicMass":58.9332,"atomicNumber":27,"ionizationEnergy":7.881,"elementGroup":"transition-metal","group":9,"name":"Cobalt","period":4,"symbol":"Co","electronsPerShell":[2,8,15,2],"discoveryDate":1735},"28":{"atomicMass":58.6934,"atomicNumber":28,"ionizationEnergy":7.6398,"elementGroup":"transition-metal","group":10,"name":"Nickel","period":4,"symbol":"Ni","electronsPerShell":[2,8,16,2],"discoveryDate":1751},"29":{"atomicMass":63.546,"atomicNumber":29,"ionizationEnergy":7.7264,"elementGroup":"transition-metal","group":11,"name":"Copper","period":4,"symbol":"Cu","electronsPerShell":[2,8,18,1],"discoveryDate":1944},"30":{"atomicMass":65.39,"atomicNumber":30,"ionizationEnergy":9.3942,"elementGroup":"transition-metal","group":12,"name":"Zinc","period":4,"symbol":"Zn","electronsPerShell":[2,8,18,2],"discoveryDate":1500},"31":{"atomicMass":69.723,"atomicNumber":31,"ionizationEnergy":5.9993,"elementGroup":"metal","group":13,"name":"Gallium","period":4,"symbol":"Ga","electronsPerShell":[2,8,18,3],"discoveryDate":1875},"32":{"atomicMass":72.64,"atomicNumber":32,"ionizationEnergy":7.8994,"elementGroup":"metalloid","group":14,"name":"Germanium","period":4,"symbol":"Ge","electronsPerShell":[2,8,18,4],"discoveryDate":1886},"33":{"atomicMass":74.9216,"atomicNumber":33,"ionizationEnergy":9.7886,"elementGroup":"metalloid","group":15,"name":"Arsenic","period":4,"symbol":"As","electronsPerShell":[2,8,18,5],"discoveryDate":1250},"34":{"atomicMass":44.9559,"atomicNumber":34,"ionizationEnergy":9.7524,"elementGroup":"non-metal","group":16,"name":"Selenium","period":4,"symbol":"Se","electronsPerShell":[2,8,9,2],"discoveryDate":1817},"35":{"atomicMass":79.904,"atomicNumber":35,"ionizationEnergy":11.8138,"elementGroup":"halogen","group":17,"name":"Bromine","period":4,"symbol":"Br","electronsPerShell":[2,8,18,7],"discoveryDate":1826},"36":{"atomicMass":83.8,"atomicNumber":36,"ionizationEnergy":13.9996,"elementGroup":"noble-gas","group":18,"name":"Krypton","period":4,"symbol":"Kr","electronsPerShell":[2,8,18,8],"discoveryDate":1898},"37":{"atomicMass":85.4678,"atomicNumber":37,"ionizationEnergy":4.1771,"elementGroup":"alkali-metal","group":1,"name":"Rubidium","period":5,"symbol":"Rb","electronsPerShell":[2,8,18,8,1],"discoveryDate":1861},"38":{"atomicMass":87.62,"atomicNumber":38,"ionizationEnergy":5.694,"elementGroup":"alkaline-earth-metal","group":2,"name":"Strontium","period":5,"symbol":"Sr","electronsPerShell":[2,8,18,8,2],"discoveryDate":1808},"39":{"atomicMass":88.9059,"atomicNumber":39,"ionizationEnergy":6.2173,"elementGroup":"transition-metal","group":3,"name":"Yttrium","period":5,"symbol":"Y","electronsPerShell":[2,8,18,9,2],"discoveryDate":1794},"40":{"atomicMass":91.224,"atomicNumber":40,"ionizationEnergy":6.6339,"elementGroup":"transition-metal","group":4,"name":"Zirconium","period":5,"symbol":"Zr","electronsPerShell":[2,8,18,10,2],"discoveryDate":1789},"41":{"atomicMass":92.9064,"atomicNumber":41,"ionizationEnergy":6.7589,"elementGroup":"transition-metal","group":5,"name":"Niobium","period":5,"symbol":"Nb","electronsPerShell":[2,8,18,12,1],"discoveryDate":1801},"42":{"atomicMass":95.94,"atomicNumber":42,"ionizationEnergy":7.0924,"elementGroup":"transition-metal","group":6,"name":"Molybdenum","period":5,"symbol":"Mo","electronsPerShell":[2,8,18,13,1],"discoveryDate":1781},"43":{"atomicMass":98,"atomicNumber":43,"ionizationEnergy":7.28,"elementGroup":"transition-metal","group":7,"name":"Technetium","period":5,"symbol":"Tc","electronsPerShell":[2,8,18,13,2],"discoveryDate":1937},"44":{"atomicMass":101.07,"atomicNumber":44,"ionizationEnergy":7.3605,"elementGroup":"transition-metal","group":8,"name":"Ruthenium","period":5,"symbol":"Ru","electronsPerShell":[2,8,18,15,1],"discoveryDate":1808},"45":{"atomicMass":102.9055,"atomicNumber":45,"ionizationEnergy":7.4589,"elementGroup":"transition-metal","group":9,"name":"Rhodium","period":5,"symbol":"Rh","electronsPerShell":[2,8,18,16,1],"discoveryDate":1803},"46":{"atomicMass":106.42,"atomicNumber":46,"ionizationEnergy":8.3369,"elementGroup":"transition-metal","group":10,"name":"Palladium","period":5,"symbol":"Pd","electronsPerShell":[2,8,18,18,0],"discoveryDate":1803},"47":{"atomicMass":107.8682,"atomicNumber":47,"ionizationEnergy":7.5762,"elementGroup":"transition-metal","group":11,"name":"Silver","period":5,"symbol":"Ag","electronsPerShell":[2,8,18,18,1],"discoveryDate":-3000},"48":{"atomicMass":112.411,"atomicNumber":48,"ionizationEnergy":8.9938,"elementGroup":"transition-metal","group":12,"name":"Cadmium","period":5,"symbol":"Cd","electronsPerShell":[2,8,18,18,2],"discoveryDate":1817},"49":{"atomicMass":114.818,"atomicNumber":49,"ionizationEnergy":5.7864,"elementGroup":"metal","group":13,"name":"Indium","period":5,"symbol":"In","electronsPerShell":[2,8,18,18,3],"discoveryDate":1863},"50":{"atomicMass":118.71,"atomicNumber":50,"ionizationEnergy":7.3439,"elementGroup":"metal","group":14,"name":"Tin","period":5,"symbol":"Sn","electronsPerShell":[2,8,18,18,4],"discoveryDate":-2100},"51":{"atomicMass":121.76,"atomicNumber":51,"ionizationEnergy":8.6084,"elementGroup":"metalloid","group":15,"name":"Antimony","period":5,"symbol":"Sb","electronsPerShell":[2,8,18,18,5],"discoveryDate":-1600},"52":{"atomicMass":127.6,"atomicNumber":52,"ionizationEnergy":9.0096,"elementGroup":"metalloid","group":16,"name":"Tellurium","period":5,"symbol":"Te","electronsPerShell":[2,8,18,18,6],"discoveryDate":1783},"53":{"atomicMass":126.9045,"atomicNumber":53,"ionizationEnergy":10.4513,"elementGroup":"halogen","group":17,"name":"Iodine","period":5,"symbol":"I","electronsPerShell":[2,8,18,18,7],"discoveryDate":1811},"54":{"atomicMass":131.293,"atomicNumber":54,"ionizationEnergy":12.1298,"elementGroup":"noble-gas","group":18,"name":"Xenon","period":5,"symbol":"Xe","electronsPerShell":[2,8,18,18,8],"discoveryDate":1898},"55":{"atomicMass":132.9055,"atomicNumber":55,"ionizationEnergy":3.8939,"elementGroup":"alkali-metal","group":1,"name":"Cesium","period":6,"symbol":"Cs","electronsPerShell":[2,8,18,18,8,1],"discoveryDate":1860},"56":{"atomicMass":137.327,"atomicNumber":56,"ionizationEnergy":5.2117,"elementGroup":"alkaline-earth-metal","group":2,"name":"Barium","period":6,"symbol":"Ba","electronsPerShell":[2,8,18,18,8,2],"discoveryDate":1808},"57":{"atomicMass":138.9055,"atomicNumber":57,"ionizationEnergy":5.5769,"elementGroup":"lanthanoid","group":2,"name":"Lanthanum","period":6,"symbol":"La","electronsPerShell":[2,8,18,18,9,2],"discoveryDate":1839},"58":{"atomicMass":140.116,"atomicNumber":58,"ionizationEnergy":5.5387,"elementGroup":"lanthanoid","group":3,"name":"Cerium","period":6,"symbol":"Ce","electronsPerShell":[2,8,18,19,9,2],"discoveryDate":1803},"59":{"atomicMass":140.9077,"atomicNumber":59,"ionizationEnergy":5.473,"elementGroup":"lanthanoid","group":4,"name":"Praseodymium","period":6,"symbol":"Pr","electronsPerShell":[2,8,18,21,8,2],"discoveryDate":1885},"60":{"atomicMass":144.24,"atomicNumber":60,"ionizationEnergy":5.525,"elementGroup":"lanthanoid","group":5,"name":"Neodymium","period":6,"symbol":"Nd","electronsPerShell":[2,8,18,22,8,2],"discoveryDate":1885},"61":{"atomicMass":145,"atomicNumber":61,"ionizationEnergy":5.582,"elementGroup":"lanthanoid","group":6,"name":"Promethium","period":6,"symbol":"Pm","electronsPerShell":[2,8,18,23,8,2],"discoveryDate":1945},"62":{"atomicMass":150.36,"atomicNumber":62,"ionizationEnergy":5.6437,"elementGroup":"lanthanoid","group":7,"name":"Samarium","period":6,"symbol":"Sm","electronsPerShell":[2,8,18,24,8,2],"discoveryDate":1879},"63":{"atomicMass":151.964,"atomicNumber":63,"ionizationEnergy":5.6704,"elementGroup":"lanthanoid","group":8,"name":"Europium","period":6,"symbol":"Eu","electronsPerShell":[2,8,18,25,8,2],"discoveryDate":1901},"64":{"atomicMass":157.25,"atomicNumber":64,"ionizationEnergy":6.1501,"elementGroup":"lanthanoid","group":9,"name":"Gadolinium","period":6,"symbol":"Gd","electronsPerShell":[2,8,18,25,9,2],"discoveryDate":1880},"65":{"atomicMass":158.9253,"atomicNumber":65,"ionizationEnergy":5.8638,"elementGroup":"lanthanoid","group":10,"name":"Terbium","period":6,"symbol":"Tb","electronsPerShell":[2,8,18,27,8,2],"discoveryDate":1843},"66":{"atomicMass":162.5,"atomicNumber":66,"ionizationEnergy":5.9389,"elementGroup":"lanthanoid","group":11,"name":"Dysprosium","period":6,"symbol":"Dy","electronsPerShell":[2,8,18,28,8,2],"discoveryDate":1886},"67":{"atomicMass":164.9303,"atomicNumber":67,"ionizationEnergy":6.0215,"elementGroup":"lanthanoid","group":12,"name":"Holmium","period":6,"symbol":"Ho","electronsPerShell":[2,8,18,29,8,2],"discoveryDate":1878},"68":{"atomicMass":167.259,"atomicNumber":68,"ionizationEnergy":6.1077,"elementGroup":"lanthanoid","group":13,"name":"Erbium","period":6,"symbol":"Er","electronsPerShell":[2,8,18,30,8,2],"discoveryDate":1842},"69":{"atomicMass":168.9342,"atomicNumber":69,"ionizationEnergy":6.1843,"elementGroup":"lanthanoid","group":14,"name":"Thulium","period":6,"symbol":"Tm","electronsPerShell":[2,8,18,31,8,2],"discoveryDate":1879},"70":{"atomicMass":173.04,"atomicNumber":70,"ionizationEnergy":6.2542,"elementGroup":"lanthanoid","group":15,"name":"Ytterbium","period":6,"symbol":"Yb","electronsPerShell":[2,8,18,32,8,2],"discoveryDate":1878},"71":{"atomicMass":174.967,"atomicNumber":71,"ionizationEnergy":5.4259,"elementGroup":"lanthanoid","group":16,"name":"Lutetium","period":6,"symbol":"Lu","electronsPerShell":[2,8,18,32,9,2],"discoveryDate":1907},"72":{"atomicMass":178.49,"atomicNumber":72,"ionizationEnergy":6.8251,"elementGroup":"transition-metal","group":4,"name":"Hafnium","period":6,"symbol":"Hf","electronsPerShell":[2,8,18,32,10,2],"discoveryDate":1923},"73":{"atomicMass":180.9479,"atomicNumber":73,"ionizationEnergy":7.5496,"elementGroup":"transition-metal","group":5,"name":"Tantalum","period":6,"symbol":"Ta","electronsPerShell":[2,8,18,32,11,2],"discoveryDate":1802},"74":{"atomicMass":183.84,"atomicNumber":74,"ionizationEnergy":7.864,"elementGroup":"transition-metal","group":6,"name":"Tungsten","period":6,"symbol":"W","electronsPerShell":[2,8,18,32,12,2],"discoveryDate":1783},"75":{"atomicMass":186.207,"atomicNumber":75,"ionizationEnergy":7.8335,"elementGroup":"transition-metal","group":7,"name":"Rhenium","period":6,"symbol":"Re","electronsPerShell":[2,8,18,32,13,2],"discoveryDate":1925},"76":{"atomicMass":190.23,"atomicNumber":76,"ionizationEnergy":8.4382,"elementGroup":"transition-metal","group":8,"name":"Osmium","period":6,"symbol":"Os","electronsPerShell":[2,8,18,32,14,2],"discoveryDate":1803},"77":{"atomicMass":192.217,"atomicNumber":77,"ionizationEnergy":8.967,"elementGroup":"transition-metal","group":9,"name":"Iridium","period":6,"symbol":"Ir","electronsPerShell":[2,8,18,32,15,2],"discoveryDate":1803},"78":{"atomicMass":195.078,"atomicNumber":78,"ionizationEnergy":8.9587,"elementGroup":"transition-metal","group":10,"name":"Platinum","period":6,"symbol":"Pt","electronsPerShell":[2,8,18,32,17,1],"discoveryDate":1700},"79":{"atomicMass":196.9665,"atomicNumber":79,"ionizationEnergy":9.2255,"elementGroup":"transition-metal","group":11,"name":"Gold","period":6,"symbol":"Au","electronsPerShell":[2,8,18,32,18,1],"discoveryDate":-3000},"80":{"atomicMass":200.59,"atomicNumber":80,"ionizationEnergy":10.4375,"elementGroup":"transition-metal","group":12,"name":"Mercury","period":6,"symbol":"Hg","electronsPerShell":[2,8,18,32,18,2],"discoveryDate":-1500},"81":{"atomicMass":204.3833,"atomicNumber":81,"ionizationEnergy":6.108,"elementGroup":"metal","group":13,"name":"Thallium","period":6,"symbol":"Tl","electronsPerShell":[2,8,18,32,18,3],"discoveryDate":1861},"82":{"atomicMass":207.2,"atomicNumber":82,"ionizationEnergy":7.4167,"elementGroup":"metal","group":14,"name":"Lead","period":6,"symbol":"Pb","electronsPerShell":[2,8,18,32,18,4],"discoveryDate":-1000},"83":{"atomicMass":208.9804,"atomicNumber":83,"ionizationEnergy":7.2856,"elementGroup":"metal","group":15,"name":"Bismuth","period":6,"symbol":"Bi","electronsPerShell":[2,8,18,32,18,5],"discoveryDate":1500},"84":{"atomicMass":209,"atomicNumber":84,"ionizationEnergy":8.417,"elementGroup":"metalloid","group":16,"name":"Polonium","period":6,"symbol":"Po","electronsPerShell":[2,8,18,32,18,6],"discoveryDate":1898},"85":{"atomicMass":210,"atomicNumber":85,"ionizationEnergy":9.3,"elementGroup":"halogen","group":17,"name":"Astatine","period":6,"symbol":"At","electronsPerShell":[2,8,18,32,18,7],"discoveryDate":1940},"86":{"atomicMass":222,"atomicNumber":86,"ionizationEnergy":10.7485,"elementGroup":"noble-gas","group":18,"name":"Radon","period":6,"symbol":"Rn","electronsPerShell":[2,8,18,32,18,8],"discoveryDate":1900},"87":{"atomicMass":223,"atomicNumber":87,"ionizationEnergy":4.0727,"elementGroup":"alkali-metal","group":1,"name":"Francium","period":7,"symbol":"Fr","electronsPerShell":[2,8,18,32,18,8,1],"discoveryDate":1939},"88":{"atomicMass":226,"atomicNumber":88,"ionizationEnergy":5.2784,"elementGroup":"alkaline-earth-metal","group":2,"name":"Radium","period":7,"symbol":"Ra","electronsPerShell":[2,8,18,32,18,8,2],"discoveryDate":1898},"89":{"atomicMass":227,"atomicNumber":89,"ionizationEnergy":5.17,"elementGroup":"actinoid","group":2,"name":"Actinium","period":7,"symbol":"Ac","electronsPerShell":[2,8,18,32,18,9,2],"discoveryDate":1899},"90":{"atomicMass":232.0381,"atomicNumber":90,"ionizationEnergy":6.3067,"elementGroup":"actinoid","group":3,"name":"Thorium","period":7,"symbol":"Th","electronsPerShell":[2,8,18,32,18,10,2],"discoveryDate":1829},"91":{"atomicMass":106.42,"atomicNumber":91,"ionizationEnergy":5.89,"elementGroup":"actinoid","group":4,"name":"Protactinium","period":7,"symbol":"Pa","electronsPerShell":[2,8,18,32,20,9,2],"discoveryDate":1917},"92":{"atomicMass":238.0289,"atomicNumber":92,"ionizationEnergy":6.1941,"elementGroup":"actinoid","group":5,"name":"Uranium","period":7,"symbol":"U","electronsPerShell":[2,8,18,32,21,9,2],"discoveryDate":1789},"93":{"atomicMass":237,"atomicNumber":93,"ionizationEnergy":6.2657,"elementGroup":"actinoid","group":6,"name":"Neptunium","period":7,"symbol":"Np","electronsPerShell":[2,8,18,32,22,9,2],"discoveryDate":1940},"94":{"atomicMass":244,"atomicNumber":94,"ionizationEnergy":6.0262,"elementGroup":"actinoid","group":7,"name":"Plutonium","period":7,"symbol":"Pu","electronsPerShell":[2,8,18,32,24,8,2],"discoveryDate":1940},"95":{"atomicMass":243,"atomicNumber":95,"ionizationEnergy":5.9738,"elementGroup":"actinoid","group":8,"name":"Americium","period":7,"symbol":"Am","electronsPerShell":[2,8,18,32,25,8,2],"discoveryDate":1994},"96":{"atomicMass":247,"atomicNumber":96,"ionizationEnergy":5.9915,"elementGroup":"actinoid","group":9,"name":"Curium","period":7,"symbol":"Cm","electronsPerShell":[2,8,18,32,25,9,2],"discoveryDate":1944},"97":{"atomicMass":247,"atomicNumber":97,"ionizationEnergy":6.1979,"elementGroup":"actinoid","group":10,"name":"Berkelium","period":7,"symbol":"Bk","electronsPerShell":[2,8,18,32,27,8,2],"discoveryDate":1949},"98":{"atomicMass":251,"atomicNumber":98,"ionizationEnergy":6.2817,"elementGroup":"actinoid","group":11,"name":"Californium","period":7,"symbol":"Cf","electronsPerShell":[2,8,18,32,28,8,2],"discoveryDate":1950},"99":{"atomicMass":252,"atomicNumber":99,"ionizationEnergy":6.42,"elementGroup":"actinoid","group":12,"name":"Einsteinium","period":7,"symbol":"Es","electronsPerShell":[2,8,18,32,29,8,2],"discoveryDate":1952},"100":{"atomicMass":257,"atomicNumber":100,"ionizationEnergy":6.5,"elementGroup":"actinoid","group":13,"name":"Fermium","period":7,"symbol":"Fm","electronsPerShell":[2,8,18,32,30,8,2],"discoveryDate":1952},"101":{"atomicMass":258,"atomicNumber":101,"ionizationEnergy":6.58,"elementGroup":"actinoid","group":14,"name":"Mendelevium","period":7,"symbol":"Md","electronsPerShell":[2,8,18,32,31,8,2],"discoveryDate":1955},"102":{"atomicMass":259,"atomicNumber":102,"ionizationEnergy":6.65,"elementGroup":"actinoid","group":15,"name":"Nobelium","period":7,"symbol":"No","electronsPerShell":[2,8,18,32,32,8,2],"discoveryDate":1958},"103":{"atomicMass":262,"atomicNumber":103,"ionizationEnergy":4.9,"elementGroup":"actinoid","group":16,"name":"Lawrencium","period":7,"symbol":"Lr","electronsPerShell":[2,8,18,32,32,8,3],"discoveryDate":1961},"104":{"atomicMass":261,"atomicNumber":104,"ionizationEnergy":0,"elementGroup":"transition-metal","group":4,"name":"Rutherfordium","period":7,"symbol":"Rf","electronsPerShell":[2,8,18,32,32,10,2]},"105":{"atomicMass":262,"atomicNumber":105,"ionizationEnergy":0,"elementGroup":"transition-metal","group":5,"name":"Dubnium","period":7,"symbol":"Db","electronsPerShell":[2,8,18,32,32,11,2]},"106":{"atomicMass":266,"atomicNumber":106,"ionizationEnergy":0,"elementGroup":"transition-metal","group":6,"name":"Seaborgium","period":7,"symbol":"Sg","electronsPerShell":[2,8,18,32,32,12,2]},"107":{"atomicMass":264,"atomicNumber":107,"ionizationEnergy":0,"elementGroup":"transition-metal","group":7,"name":"Bohrium","period":7,"symbol":"Bh","electronsPerShell":[2,8,18,32,32,13,2]},"108":{"atomicMass":277,"atomicNumber":108,"ionizationEnergy":0,"elementGroup":"transition-metal","group":8,"name":"Hassium","period":7,"symbol":"Hs","electronsPerShell":[2,8,18,32,32,14,2]},"109":{"atomicMass":268,"atomicNumber":109,"ionizationEnergy":0,"elementGroup":"transition-metal","group":9,"name":"Meitnerium","period":7,"symbol":"Mt","electronsPerShell":[2,8,18,32,32,15,2]},"110":{"atomicMass":108,"atomicNumber":110,"ionizationEnergy":0,"elementGroup":"transition-metal","group":10,"name":"Darmstadtium","period":7,"symbol":"Ds","electronsPerShell":[2,8,18,32,32,16,2]},"111":{"atomicMass":282,"atomicNumber":111,"ionizationEnergy":0,"elementGroup":"transition-metal","group":11,"name":"Roentgenium","period":7,"symbol":"Rg","electronsPerShell":[2,8,18,32,32,17,2]},"112":{"atomicMass":285,"atomicNumber":112,"ionizationEnergy":0,"elementGroup":"transition-metal","group":12,"name":"Copernicium","period":7,"symbol":"Cn","electronsPerShell":[2,8,18,32,32,18,2]},"113":{"atomicMass":112,"atomicNumber":113,"ionizationEnergy":0,"elementGroup":"metal","group":13,"name":"Ununtrium","period":7,"symbol":"Uut","electronsPerShell":[2,8,18,32,32,18,3]},"114":{"atomicMass":289,"atomicNumber":114,"ionizationEnergy":0,"elementGroup":"metal","group":14,"name":"Flerovium","period":7,"symbol":"Fl","electronsPerShell":[2,8,18,32,32,18,4],"discoveryDate":1886},"115":{"atomicMass":114,"atomicNumber":115,"ionizationEnergy":0,"elementGroup":"metal","group":15,"name":"Ununpentium","period":7,"symbol":"Uup","electronsPerShell":[2,8,18,32,32,18,5]},"116":{"atomicMass":293,"atomicNumber":116,"ionizationEnergy":0,"elementGroup":"metal","group":16,"name":"Livermorium","period":7,"symbol":"Lv","electronsPerShell":[2,8,18,32,32,18,6]},"117":{"atomicMass":116,"atomicNumber":117,"ionizationEnergy":0,"elementGroup":"halogen","group":17,"name":"Ununseptium","period":7,"symbol":"Uus","electronsPerShell":[2,8,18,32,32,18,7]},"118":{"atomicMass":117,"atomicNumber":118,"ionizationEnergy":0,"elementGroup":"noble-gas","group":18,"name":"Ununoctium","period":7,"symbol":"Uuo","electronsPerShell":[2,8,18,32,32,18,8]}},"fr_FR":{"1":{"name":"Hydrogène","phase":"gaz","context":"Ce gaz a été mis en en évidence par Cavendish en 1766, qui l'a appelé « air inflammable » parce qu'il brûle ou explose en présence de l'oxygène pour former de la vapeur d'eau. Lavoisier a désigné ce gaz par le nom hydrogène, qui est composé du préfixe « hydro », du grec ὕδωρ (hudôr) signifiant « eau », et du suffixe « gène », du grec γεννᾰν (gennan), « engendrer »."},"2":{"name":"Hélium","phase":"gaz","context":"Le mot hélium a été construit à partir du grec Helios (Ἥλιος / Hếlios, « le Soleil »), cet élément ayant été observé pour la première fois dans le spectre solaire le 18 août 1868, au cours d'une éclipse totale de Soleil, par l'astronome Jules Janssen."},"3":{"name":"Lithium","phase":"solide","context":"Le lithium pur est un métal mou, de couleur gris argenté, qui se ternit et s'oxyde très rapidement au contact de l'air et de l'eau, prenant une teinte gris foncé virant rapidement à l'anthracite et au noir. C'est l'élément solide le plus léger. Comme les autres métaux alcalins, le lithium métallique réagit facilement avec l'air et avec l'eau. Il est pour cette raison conservé dans de l'huile minérale pour le préserver de l'air."},"4":{"name":"Béryllium","phase":"solide","context":"Le nom béryllium vient du mot grec βήρυλλος (beryllos), béryl, qui vient lui-même de bêrullos, cristal. À une époque il était nommé glucinium, du grec γλύκύς (glykys), doux, un qualificatif dû au goût sucré de ses sels. Cet élément aurait été découvert par Louis-Nicolas Vauquelin, en 1798, sous forme d'oxyde (BeO) dans le béryl et dans les émeraudes. Friedrich Wöhler et Antoine Bussy l'isolèrent indépendamment en 1828 en faisant réagir du potassium sur du chlorure de béryllium. Sa masse atomique fut déterminée par le chimiste suédois."},"5":{"name":"Bore","phase":"solide","context":"Cet élément ne fut isolé qu'en 1808 par Sir Humphry Davy, Gay-Lussac et le baron Louis Jacques Thénard, qui obtinrent une pureté de 50 %. Ils n'identifièrent toutefois pas la substance comme un élément; ce fut fait par Jöns Jacob Berzélius en 1824. Henri Moissan livra les premiers échantillons purifiés et le premier échantillon de bore pur fut obtenu, à partir de sesquioxyde de bore, par le chimiste américain Ezekiel Weintraub en 1909."},"6":{"name":"Carbone","phase":"solide","context":"Le nom carbone vient du latin carbo, carbōnis (« charbon »). La fabrication de carbone sous forme de charbon de bois par carbonisation de bois sous une couche de terre était aussi connu des Romains. Le carbone sous sa forme diamant est connu depuis l'antiquité en Asie, il est aussi mentionné dans l'ancien testament. Son nom vient aussi du romain adámas, adámantis (\"acier dur\")."},"7":{"name":"Azote","context":"Antoine Lavoisier a choisi le nom azote, composé de a- (privatif) et du radical grec ζωτ- (« vivant ») et qui signifie donc « privé de vie », du fait que contrairement à l'oxygène il n'entretient pas la vie des animaux. L'origine du symbole N est son nom latin nitrogenium qui provient du grec nitron gennan, ce qui signifie « formateur de salpêtre » (nitrate de potassium). Le terme anglais nitrogen a conservé cette racine pour désigner l'azote, alors que le terme français « nitrogène » n'est plus utilisé de nos jours."},"8":{"name":"Oxygène","context":"Une molécule de formule chimique O2, appelée communément « oxygène » et, par les chimistes, dioxygène est constituée de deux atomes d'oxygène reliés par liaison covalente : aux conditions normales de température et de pression, le dioxygène est un gaz, qui constitue 20,8 % du volume de l'atmosphère terrestre au niveau de la mer."},"9":{"name":"Fluor","context":"Le fluor est le plus réactif des éléments chimiques, il est d'ailleurs généralement lié à d'autres éléments. Il possède la plus forte électronégativité, d'une valeur de 3,98. Il est le 13e élément le plus abondant dans la croûte terrestre. Quelques plantes et certaines bactéries peuvent synthétiser des composés fluorés, mais le fluor n'a aucun rôle métabolique chez les mammifères."},"10":{"name":"Néon","context":"Le néon est le second gaz rare, il possède 40 fois la capacité de réfrigération de l'hélium liquide et trois fois celle de l'hydrogène liquide (à volume égal). Dans la plupart des applications, c'est un réfrigérant moins cher que l'hélium."},"11":{"name":"Sodium","context":"Le sodium est depuis longtemps reconnu dans les composés, mais il ne fut pas isolé avant 1807, lorsque Sir Humphry Davy réalisa l'électrolyse de la soude caustique. Pendant le Moyen Âge, un composé du sodium avec le nom latin de sodanum était utilisé pour le traitement des maux de tête. Le symbole du sodium, Na, vient du nom latin d'un composé du sodium appelé natrium, qui lui-même vient du grec νίτρον (nitron), un carbonate de sodium naturel (le natron). En allemand, comme en danois ou en néerlandais, sodium se dit natrium."},"12":{"name":"Magnésium","context":"Le nom magnésium provient du nom grec d'un district de Thessalie appelé Magnesia. Cette région était extrêmement riche en magnésium, et ce sous différentes formes. En Angleterre, Joseph Black reconnut le magnésium comme un élément en 1755, et Sir Humphry Davy isola la forme métallique pure par électrolyse en 1808 à partir d'un mélange de magnésie MgO et d'oxyde de mercure HgO."},"13":{"name":"Aluminium","context":"L'aluminium est un produit industriel important, sous forme pure ou alliée, notamment dans l'aéronautique, les transports et la construction. Sa nature réactive en fait également un catalyseur et un additif dans l'industrie chimique ; il est ainsi utilisé pour accroître la puissance explosive du nitrate d'ammonium."},"14":{"name":"Silicium","context":"C'est l'élément le plus abondant dans la croûte terrestre après l'oxygène, soit 25,7 % de sa masse, mais il n'est comparativement présent qu'en relativement faible quantité dans la matière constituant le vivant. Il n'existe pas dans la nature à l'état de corps simple, mais sous forme de composés : sous forme de dioxyde de silicium (SiO2), d'origine biogène (fabriqué par un organisme vivant comme les diatomées ou les radiolaires), on le trouve sous forme de silice amorphe (dans le sable, ou d'origine lithogénique lorsqu'il est sous la forme de silice minérale, le quartz, la cristobalite, etc.), ou d'autres silicates (dans les feldspaths, la kaolinite…)."},"15":{"name":"Phosphore","context":"Le nom dérive du mot grec φώσφορος (phosphoros), qui signifie « porteur de lumière » et évoque la planète Vénus, l'étoile du berger. Cette origine a été attribuée au fait que le phosphore blanc émet de la lumière visible dans l'obscurité quand il est exposé à l'air, par chimiluminescence."},"16":{"name":"Soufre","context":"C'est un non-métal multivalent abondant, insipide, et insoluble dans l'eau. Le soufre est surtout connu sous la forme de cristaux jaunes et se trouve dans beaucoup de minéraux (sulfure et sulfate) et même sous forme native, particulièrement dans les régions volcaniques. L'essentiel du soufre exploité est cependant d'origine sédimentaire."},"17":{"name":"Chlore","context":"C'est le chimiste suédois Carl Wilhelm Scheele qui est réputé avoir isolé le dichlore le premier en 1774. Il lui donna le nom d'acide muriatique déphlogistiqué, car il pensait que c'était un gaz composé. Avec l'abandon du phlogistique, on crut, pendant quelques années que ce gaz contenait de l'oxygène, et ce n'est qu'en 1809 que le chimiste britannique Humphry Davy prouva qu'il n'en était pas ainsi, reconnut que c'était un gaz simple, et lui donna son nom actuel de chlore."},"18":{"name":"Argon","context":"Le mot argon dérive du grec ancien ἀργός / argós (« oisif », « paresseux », « stérile »), formé du préfixe grec privatif ἀ et du mot ἔργον / ergon (« travail »), cette étymologie évoquant le caractère inerte de l'élément. La présence dans l’air de l’argon fut suspectée par Henry Cavendish dès 1785 mais sa découverte par Lord Rayleigh et Sir William Ramsay attendit 1894. Ces deux scientifiques firent à la Royal Society la communication officielle de leur découverte le 31 janvier 1895."},"19":{"name":"Potassium"},"20":{"name":"Calcium"},"21":{"name":"Scandium"},"22":{"name":"Titane"},"23":{"name":"Vanadium"},"24":{"name":"Chrome"},"25":{"name":"Magnèse"},"26":{"name":"Fer"},"27":{"name":"Cobalt"},"28":{"name":"Nickel"},"29":{"name":"Cuivre"},"30":{"name":"Zinc"},"31":{"name":"Gallium"},"32":{"name":"Germanium"},"33":{"name":"Arsenic"},"34":{"name":"Sélénium"},"35":{"name":"Brome"},"36":{"name":"Krypton"},"37":{"name":"Rubidium"},"38":{"name":"Strontium"},"40":{"name":"Zirconium"},"41":{"name":"Niobium"},"42":{"name":"Molybdène"},"43":{"name":"Technétium"},"44":{"name":"Ruthénium"},"45":{"name":"Rhodium"},"46":{"name":"Palladium"},"47":{"name":"Argent"},"48":{"name":"Cadmium"},"49":{"name":"Indium"},"50":{"name":"Étain"},"51":{"name":"Antimoine"},"52":{"name":"Tellure"},"53":{"name":"Iode"},"54":{"name":"Xénon"},"55":{"name":"Césium"},"56":{"name":"Baryum"},"57":{"name":"Lanthane"},"58":{"name":"Cérium"},"59":{"name":"Praséodyme"},"60":{"name":"Néodyme"},"61":{"name":"Prométhium"},"62":{"name":"Samarium"},"63":{"name":"Europium"},"64":{"name":"Gadolinium"},"65":{"name":"Terbium"},"66":{"name":"Dysprosium"},"67":{"name":"Holmium"},"68":{"name":"Erbium"},"69":{"name":"Thulium"},"70":{"name":"Ytterbium"},"71":{"name":"Lutécium"},"72":{"name":"Hafnium"},"73":{"name":"Tantale"},"74":{"name":"Tungstène"},"75":{"name":"Rhénium"},"76":{"name":"Osmium"},"77":{"name":"Iridium"},"78":{"name":"Platine"},"79":{"name":"Or"},"80":{"name":"Mercure"},"81":{"name":"Thallium"},"82":{"name":"Plomb"},"83":{"name":"Bismuth"},"84":{"name":"Polonium"},"85":{"name":"Astate"},"86":{"name":"Radon"},"87":{"name":"Francium"},"88":{"name":"Radium"},"89":{"name":"Actinium"},"90":{"name":"Thorium"},"91":{"name":"Protactinium"},"92":{"name":"Uranium"},"93":{"name":"Neptunium"},"94":{"name":"Plutonium"},"95":{"name":"Américium"},"96":{"name":"Curium"},"97":{"name":"Berkélium"},"98":{"name":"Californium"},"99":{"name":"Einsteinium"},"100":{"name":"Fermium"},"101":{"name":"Mendélèvium"},"102":{"name":"Nobélium"},"103":{"name":"Lawrencium"},"104":{"name":"Rutherfordium"},"105":{"name":"Dubnium"},"106":{"name":"Seaborgium"},"107":{"name":"Bohrium"},"108":{"name":"Hassium"},"109":{"name":"Meitnérium"},"110":{"name":"Darmstadtium"},"111":{"name":"Roentgenium"},"112":{"name":"Copernicium"},"113":{"name":"Nihonium"},"114":{"name":"Flérovium"},"115":{"name":"Moscovium"},"116":{"name":"Livermorium"},"117":{"name":"Tennesse"},"118":{"name":"Oganesson"}},"tr_TR":{"1":{"name":"Hidrojen"},"2":{"name":"Helyum"},"3":{"name":"Lityum"},"4":{"name":"Berilyum"},"5":{"name":"Bor"},"6":{"name":"Karbon"},"7":{"name":"Azot"},"8":{"name":"Oksijen"},"9":{"name":"Flor"},"10":{"name":"Neon"},"11":{"name":"Sodyum"},"12":{"name":"Magnezyum"},"13":{"name":"Aluminyum"},"14":{"name":"Silisyon"},"15":{"name":"Fosfor"},"16":{"name":"Kükürt"},"17":{"name":"Klor"},"18":{"name":"Argon"},"19":{"name":"Potasyum"},"20":{"name":"Kalsiyum"},"21":{"name":"Skandiyum"},"22":{"name":"Titanyium"},"23":{"name":"Vanadyum"},"24":{"name":"Krom"},"25":{"name":"Mangan"},"26":{"name":"Demir"},"27":{"name":"Kobalt"},"28":{"name":"Nikel"},"29":{"name":"Bakır"},"30":{"name":"Çinko"},"31":{"name":"Galyum"},"32":{"name":"Germanyum"},"33":{"name":"Arsenik"},"34":{"name":"Selenyum"},"35":{"name":"Brom"},"36":{"name":"Kripton"},"37":{"name":"Rubidyum"},"38":{"name":"Stronsiyum"},"39":{"name":"İtriyum"},"40":{"name":"Zirkonyum"},"41":{"name":"Niobyum"},"42":{"name":"Molibden"},"43":{"name":"Teknesyum"},"44":{"name":"Rutenyum"},"45":{"name":"Rodyum"},"46":{"name":"Paladyum"},"47":{"name":"Gümüş"},"48":{"name":"Kadmiyum"},"49":{"name":"Indiyum"},"50":{"name":"Kalay"},"51":{"name":"Antimon"},"52":{"name":"Tellür"},"53":{"name":"Iyot"},"54":{"name":"Ksenon"},"55":{"name":"Sezyum"},"56":{"name":"Baryum"},"57":{"name":"Lantan"},"58":{"name":"Seryum"},"59":{"name":"Praseodim"},"60":{"name":"Neodimyum"},"61":{"name":"Prometyum"},"62":{"name":"Samaryum"},"63":{"name":"Evropiyum"},"64":{"name":"Gadolinyum"},"65":{"name":"Terbiyum"},"66":{"name":"Disprosyum"},"67":{"name":"Holmiyum"},"68":{"name":"Erbiyum"},"69":{"name":"Tulyum"},"70":{"name":"İterbiyum"},"71":{"name":"Lütesyum"},"72":{"name":"Hafniyum"},"73":{"name":"Tantal"},"74":{"name":"Volfram/Tungsten"},"75":{"name":"Renyum"},"76":{"name":"Osmiyum"},"77":{"name":"İridyum"},"78":{"name":"Platin"},"79":{"name":"Altın"},"80":{"name":"Civa"},"81":{"name":"Thalyum"},"82":{"name":"Kurşun"},"83":{"name":"Bizmut"},"84":{"name":"Polonyum"},"85":{"name":"Astatin"},"86":{"name":"Radon"},"87":{"name":"Fransiyum"},"88":{"name":"Radyum"},"89":{"name":"Aktinyum"},"90":{"name":"Toryum"},"91":{"name":"Protaktinyum"},"92":{"name":"Uranyum"},"93":{"name":"Neptünyum"},"94":{"name":"Plütonyum"},"95":{"name":"Amerikyum"},"96":{"name":"Küriyum"},"97":{"name":"Berkelyum"},"98":{"name":"Kaliforniyum"},"99":{"name":"Aynştanyum"},"100":{"name":"Fermyum"},"101":{"name":"Mendelevyum"},"102":{"name":"Nobelyum"},"103":{"name":"Lavrensiyum/Lorentiyum"},"104":{"name":"Rutherfordiyum"},"105":{"name":"Dubniyum"},"106":{"name":"Seaborgiyum"},"107":{"name":"Bohriyum"},"108":{"name":"Hassiyum"},"109":{"name":"Metneriyum"},"110":{"name":"Darmstadtiyum"},"111":{"name":"Röntgenyum"},"112":{"name":"Kopernikyum"},"113":{"name":"Ununtriyum"},"114":{"name":"Flerovium/Ununkuadyum"},"115":{"name":"Ununpentiyum"},"116":{"name":"Livermoryum/Ununheksiyum"},"117":{"name":"Ununseptiyum"},"118":{"name":"Ununoktiyum"}}}

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.jpg": 620
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 660;

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

module.exports = {"home":{"gameMode":"Game mode","about":"About"},"about":{"title":"About Mendelable","primaryText":"Mendelable is an open-source project hosted on <a href=\"https://github.com/pulsardev/mendelable\" target=\"_blank\">GitHub</a>, developed by the team <a href=\"https://pulsar.surge.sh/\"><i>Pulsar</i></a> and to which you can contribute through this form or pull requests. You can contact us if you find an error in our data, if you have a technical issue or if you just have a simple question.","featuredText":"Mendelable has been featured in Smashing Magazine in the context of the \"CSS Grid Challenge\".","helpUsText":"Feel free to donate to support us and help us rent a server for this website.","donate":"Donate"},"contact":{"form":{"name":{"label":"Your name","validation":"Please enter your name."},"email":{"label":"Your email","validation":"Please enter your email address.","helpText":"We'll not share your email with anyone else.","error":"Please enter a valid email address."},"message":{"label":"Your message","validation":"Please enter a message."},"submit":"Submit"}},"general":{"search":"Search","temperature":"Temperature"},"history":{"generalInformation":"General information","discoveredBy":"Discovery by","discoveryDate":"Discovery date","context":"Context"},"sidebar":{"title":"Options","subtitle":"Options of the current page","legend":"Legend","elementProfile":{"previous":"Previous","next":"Next"},"simpleView":"Simple view"},"game":{"play":"Play","stop":"Stop","input":"Enter an element's name","elementsFound":"elements found"},"language":{"label":"Language"},"element":{"atomicNumber":"Atomic number","electronsPerShell":"Electrons per shell","physicalProperties":"Physical properties","meltingPoint":"Melting point","boilingPoint":"Boiling point","atomicMass":"Atomic mass","ionizationEnergy":"Ionization energy","group":{"non-metal":"Nonmetals","halogen":"Halogens","metalloid":"Metalloids","metal":"Metals","alkali-metal":"Alkali metals","alkaline-earth-metal":"Alkaline earth metals","transition-metal":"Transition metals","noble-gas":"Noble gases","lanthanoid":"Lanthanoids","actinoid":"Actinoids"}}}

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports = {"home":{"gameMode":"Mode jeu","about":"À propos"},"about":{"title":"À propos de Mendelable","primaryText":"Mendelable est un projet open-source hébergé sur <a href=\"https://github.com/pulsardev/mendelable\" target=\"_blank\">GitHub</a>, développé par l'équipe <a href=\"https://pulsar.surge.sh/\"><i>Pulsar</i></a> et auquel vous pouvez contribuez grâce à ce formulaire ou à des pull requests. N'hésitez pas à nous contacter si vous trouvez une erreur dans nos données, si vous rencontrez un problème technique ou tout simplement si vous avez une question.","featuredText":"Mendelable a été mis en avant sur Smashing Magazine dans le cadre du \"CSS Grid Challenge\".","helpUsText":"Vous êtes libre de faire un don pour nous soutenir et nous aider à louer un serveur pour ce site.","donate":"Faire un don"},"contact":{"form":{"name":{"label":"Votre nom","validation":"Veuillez entrer votre nom."},"email":{"label":"Votre email","validation":"Veuillez entrer votre email.","helpText":"Nous ne partagerons pas votre email.","error":"Veuillez entrer une adresse email valide."},"message":{"label":"Votre message","validation":"Veuillez entrer votre message."},"submit":"Envoyer"}},"general":{"search":"Rechercher","temperature":"Température"},"history":{"generalInformation":"Informations générales","discoveredBy":"Découvert par","discoveryDate":"Date de découverte","context":"Contexte"},"sidebar":{"title":"Options","subtitle":"Options de la page courante","legend":"Légende","elementProfile":{"previous":"Précédent","next":"Suivant"},"simpleView":"Vue simple"},"game":{"play":"Jouer","stop":"Arrêter","input":"Entrez le nom d'un élément","elementsFound":"éléments trouvés"},"language":{"label":"Langue"},"element":{"atomicNumber":"Numéro atomique","electronsPerShell":"Électrons par couche","physicalProperties":"Propriétés physiques","meltingPoint":"Point de fusion","boilingPoint":"Point d'ébullition","atomicMass":"Masse atomique","ionizationEnergy":"Énergie d'ionisation","group":{"non-metal":"Non-métaux","halogen":"Halogènes","metalloid":"Métalloïdes","metal":"Métaux","alkali-metal":"Métaux alcalins","alkaline-earth-metal":"Métaux alcalino-terreux","transition-metal":"Métaux de transition","noble-gas":"Gaz nobles","lanthanoid":"Lanthanides","actinoid":"Actinides"}}}

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

module.exports = {"home":{"gameMode":"Oyun modu","about":"Hakkında"},"about":{"title":"Mendelable Hakkında","primaryText":"Mendelable bir açık-kaynak projesidir ve <a href=\"https://github.com/pulsardev/mendelable\" target=\"_blank\">GitHub</a> alanında barındırılır, <a href=\"https://pulsar.surge.sh/\"><i>Pulsar</i></a> ekibi tarafından geliştirilmiştir ve bu form aracılığıyla katkı veya taleplerde bulunabilirsiniz. Verilerimizde bir hata bulursanız, teknik bir sorunuz veya basit bir sorunuz varsa bizimle iletişime geçebilirsiniz.","helpUsText":"Bize destek olmak ve bu web sitesi için bir sunucu kiralamıza yardımcı olmak için bağış yapmaktan çekinmeyin.","donate":"Yardım et"},"contact":{"form":{"name":{"label":"Adınız","validation":"Lütfen adınızı giriniz."},"email":{"label":"Emailiniz","validation":"Lütfen email adresinizi giriniz.","helpText":"Biz emailinizi başkaları ile paylaşmayacağız.","error":"Lütfen geçerli email adresinizi giriniz."},"message":{"label":"Mesajınız","validation":"Lütfen bir mesaj yazınız."},"submit":"Kaydet"}},"general":{"search":"Arama","temperature":"Sıcaklık"},"history":{"generalInformation":"Genel bilgi","discoveredBy":"tarafından keşfedilmiştir","discoveryDate":"Keşif tarihi","context":"İçerik"},"sidebar":{"title":"Seçenekler","subtitle":"Geçerli sayfanın seçenekleri","legend":"Yazıt","elementProfile":{"previous":"Önceki","next":"Sonraki"},"simpleView":"Basit görünüş"},"game":{"play":"Oynat","stop":"Durdur","input":"Bir element adı giriniz","elementsFound":"bulunan elementler"},"language":{"label":"Lisan"},"element":{"atomicNumber":"Atom numarası","electronsPerShell":"Her kabuktaki elektron sayısı","physicalProperties":"Fiziksel özellikler","meltingPoint":"Buharlaşma noktası","boilingPoint":"Kaynama noktası","atomicMass":"Atomik kütle","ionizationEnergy":"İyonlaşma enerjisi","group":{"non-metal":"Ametaller","halogen":"Halojenler","metalloid":"Metaloidler/Bileşikler","metal":"Metaller","alkali-metal":"Alkali/Bazik metaller","alkaline-earth-metal":"Toprak alkali metaller","transition-metal":"Geçiş metalleri","noble-gas":"Soy gazlar","lanthanoid":"Lantanidler/Nâdir toprak elementleri","actinoid":"Aktinidler"}}}

/***/ })

},[303]);


// WEBPACK FOOTER //
// static/js/app.61987aa1a29c620ad2b1.js